/* eslint-disable react-native/sort-styles */
import { StyleSheet } from "react-native";
import { kColors } from "./kColors";
import { kFonts } from "./kFonts";

// component and spacing constants
export const kStyleConst = {
  kPromotionHeight: 166,
  kStoreDrawerWidth: 160,
  kNet30SetupWidth: 150,
  kPromotionMaxWidth: 651,
  kSpacing: 5,
  kShimmerMessages: 2,
  kStoreFrontExclusiveBadgeHeight: 19,
  kSimmerHeight: 50,
  kVariantCheckBoxMaxWidth: 60,
  kVariantCheckBoxTextMaxWidth: 80,
  kApplyMinWidth: 200,
  kRadioButton: 15,
  kBadgeHeight: 10,
  kFontSizeMedium: 14,
  kFontSizeBrandCartDelete: 25,
  kHeaderHeight: 92,
  kErrorHeight: 45,
  kSubHeaderHeight: 36,
  kSubHeaderHeightSmall: 4,
  kApplicationNotesBoxHeight: 240,
  kPromoDescriptionBoxHeight: 140,
  kSearchContainerWidth: 190,
  kLongButtonWidth: 250,
  kSmallButtonWidth: 40,
  kSmallButtonHeight: 40,
  kPlusMinusButton: { height: 20, width: 20 },
  kNumberInput: { height: 20, width: 35 },
  kOrderStatusDot: { height: 7, width: 7 },
  kProductPicSmall: { height: 31, width: 31 },
  kHamburgerIcon: { height: 25, width: 25 },
  kCancelIcon: { height: 10, width: 10 },
  kDeleteCartItemIcon: { height: 20, width: 20 },
  kCheckBox: { height: 15, width: 15 },
  kSpinner: { height: 20, width: 20 },
  kAlertDot: { height: 10, width: 10 },
  kStandardButtons: { height: 40, minWidth: 191 },
  kSmallButtons: { height: 24 },
  kImportBig: { width: 40, height: 40 },
  kImportSmall: { width: 25, height: 25 },
  kOrderSummaryAlertContainer: { height: 119, width: 345 },
  kOrderSummaryContainer: { height: 63, width: 345 },
  kImageSelect: { width: 141, height: 141 },
  kImageSelectPrimary: { width: 227, height: 227 },
  kImageSelectBrandReadModelImage1: { width: 590, height: 390 },
  kDropDownIcon: { width: 30, height: 30 },
  kDropDownIconShop: { width: 20, height: 20 },
  kDrawerWidth: 310,
  kDrawerWidthSmall: 126,
  kFooterHeight: 239,
  kFooterSloganWidth: 250,
  kFooterHeightSmall: 30,
  kFormHeight: 65,
  kMinWidth: 300,
  kConvoProfileContainerWidth: 200,
  kTopBannerContainer: { height: 50, width: 345 },
  kBannerHeight: 197,
  kBorderWidth: 1,
  kCartItemTitleTextBox: 300,
  kQuantityChangeBox: { height: 20, minWidth: 20, maxWidth: 25 },
  kQuantityChangeBoxDownSymbol: { height: 1.43, width: 8.57 },
  kQuantityChangeBoxUpSymbol: { height: 8.57, width: 8.57 },
  kBrandCartShipPOBox: { height: 40, width: 196 },
  kBorderRadius: 2,
  kLegendStamp: { width: 20, height: 20 },
  kDrawerSeparatorsWidth: { height: 2, width: 201 },
  kDrawerTopSeparatorHeight: 1,
  kDrawerAlgoliaSeparatorsWidth: { height: 2, width: 100 },
  kDrawerAlgoliaSeparatorsBrands: { height: 2, width: 20 },
  kHeroBannerHeight: 380,
  kTmtTitle: { width: 221, height: 46 },
  kBrandBannerHeight: 300,
  kBrandIconDiameter: 223,
  kBrandIconMobileDiameter: 100,
  kBrandBannerHeightSmall: 170,
  kBrandIconDiameterSmall: 100,
  kBrandLandingBookmarkDimensions: { width: 18, height: 26 },
  kReadStoryButtonWidth: 115,
  kReadStoryModelWidth: 223,
  kAddToCartButtonDimensions: { height: 50 },
  kThumbnailDimensions: { width: 55 },
  kDotDimensions: { width: 5, height: 5 },
  kQuantityInputDimensions: { width: 80, height: 30 },
  kTopBarHeight: 4,
  kAddToCartDisabledOpacity: 0.8,
  kImageThumbnailOpacity: 0.3,
  kBorderWidthSmall: 0.75,
  kBorderWidthLarge: 1.75,
  kHeaderIcon: { width: 50, height: 50 },
  kTableDotSizing: 7,
  kTableSortArrowSizing: { width: 12, height: 12 },
  kDashboardHorizontalPadding: 64,
  kDashboardVerticalPadding: 72,
  kDashboardEyebrowsMaxWidth: 300,
  kCartBadgeDimension: 12,
  kCartBadgeTop: -4,
  kCartBadgeRight: 15,
  kDrawerBackButtonDimensions: { height: 16, width: 20 },
  kHeaderBackButtonDimensions: { height: 18, width: 12.46 },
  kSlightLetterSpacing: 1.2,
  kExternalLinkIconDimensions: { height: 10, width: 10 },
  kTagDeleteIconDimensions: { height: 10, width: 10 },
  kAddImageDiscardDimensions: { height: 20, width: 20 },
  kAddVariantButtonDimensions: {
    height: 40,
    paddingHorizontal: 25,
  },
  kMessageInputHeight: 100,
  kListProductImageThumbnail: { height: 30, width: 30 },
  kTableProfileImageDimension: 30,
  kOneByOne: { height: 1, width: 1 },
  kConversationAvatarDimension: 70,
  kConfigureButtonBorderWidth: 5,
  kTesterBadgeHeight: 20,
  kProfileSocialButtonSize: 25,
  kProfileAvatarSize: 180,
};

export const old_styles = StyleSheet.create({
  addedMarginBottom: { marginBottom: 2 * kStyleConst.kSpacing },
  darkGreenText: { color: kColors.brandDarkGreen },
  fMenuTitle: {
    ...kFonts.menuTitle,
    color: kColors.brandDark,
  },

  fBodyLightBlack: {
    ...kFonts.bodyLight,
    color: kColors.brandDark,
  },
  fPageTitleBlack: {
    ...kFonts.pageTitle,
    color: kColors.brandDark,
    marginBottom: 2 * kStyleConst.kSpacing,
  },
  fBodyMediumBlack: {
    ...kFonts.bodyMedium,
  },
  fSubHeaderWhite: {
    ...kFonts.subHeader,
    color: kColors.white,
  },
  fSubHeaderDivider: {
    ...kFonts.subHeader,
    color: kColors.white,
    marginEnd: 6 * kStyleConst.kSpacing,
  },
  fHeader: {
    ...kFonts.header,
  },
  fFacetBlack: {
    ...kFonts.facet,
    color: kColors.brandDark,
  },
  fFacetSelectedBlack: {
    ...kFonts.facetSelected,
    color: kColors.black,
  },
  fPoppinsLightBlack: {
    ...kFonts.poppinsLight,
    color: kColors.black,
  },
  fPoppinsRegularBrandDark: {
    ...kFonts.poppinsRegular,
    color: kColors.brandDark,
  },
  fPoppinsBoldBlack: {
    ...kFonts.poppinsBold,
    color: kColors.black,
  },
  fPoppinsSmallRegularWhite: {
    ...kFonts.poppinsSmallRegular,
    color: kColors.white,
  },
  fPoppinsSmallRegularBrandDark: {
    ...kFonts.poppinsSmallRegular,
    color: kColors.brandDark,
    paddingBottom: 0.6 * kStyleConst.kSpacing,
  },
  fPoppinsSmallBoldBrandDark: {
    ...kFonts.poppinsSmallBold,
    color: kColors.brandDark,
  },
  fPoppinsExtraSmallWhite: {
    ...kFonts.poppinsExtraSmall,
    color: kColors.white,
  },
  fPoppinsExtraSmallWhiteBrandModel: {
    ...kFonts.poppinsExtraSmall,
    color: kColors.white,
    backgroundColor: kColors.brandGreen,
    borderRadius: 999,
    paddingHorizontal: 2 * kStyleConst.kSpacing,
    paddingVertical: kStyleConst.kSpacing,
    marginLeft: 2 * kStyleConst.kSpacing,
  },
  fPoppinsExtraSmallWhiteBrandModelSmall: {
    ...kFonts.poppinsExtraSmall,
    color: kColors.white,
    backgroundColor: kColors.brandGreen,
    borderRadius: 999,
    paddingHorizontal: 2 * kStyleConst.kSpacing,
    paddingVertical: kStyleConst.kSpacing,
    alignSelf: "flex-start",
  },
  fPoppins400BrandDark: {
    ...kFonts.poppins400,
    color: kColors.brandDark,
  },
  fPoppinsRegularWhite: {
    ...kFonts.poppinsRegular,
    color: kColors.white,
  },
  fPoppinsLargeLightBrandDark: {
    ...kFonts.poppinsLargeLight,
    color: kColors.brandDark,
  },
  RED_BACKGROUND: {
    backgroundColor: kColors.red,
  },
  gNewMessageDot: {
    ...kStyleConst.kAlertDot,
    backgroundColor: kColors.secondaryRed,
    borderRadius: 999,
  },
  P01_02_BackButton: { width: 200, marginTop: 50, borderWidth: 0, backgroundColor: kColors.brandGreen },
  P01_02_BodyText: {
    textAlign: "center",
  },
  P01_02_ButtonText: { color: kColors.white },
  P01_02_ContentView: {
    backgroundColor: kColors.white,
    borderRadius: 4 * kStyleConst.kBorderRadius,
    flex: 1,
    padding: 6 * kStyleConst.kSpacing,
    marginHorizontal: 18 * kStyleConst.kSpacing,
    marginVertical: 10 * kStyleConst.kSpacing,
    alignItems: "center",
    justifyContent: "center",
  },
  P01_02_ContentViewSmall: {
    backgroundColor: kColors.white,
    flex: 1,
    paddingHorizontal: 16 * kStyleConst.kSpacing,
    PaddingTop: 10 * kStyleConst.kSpacing,
    PaddingBottom: 32 * kStyleConst.kSpacing,
    alignItems: "center",
    justifyContent: "center",
  },
  P01_02_PageView: { alignItems: "stretch", justifyContent: "center", flex: 1, backgroundColor: kColors.brandLight },
  P01_02_TitleText: {
    ...kFonts.profileHeader,
    color: kColors.black,
    marginBottom: 5 * kStyleConst.kSpacing,
    textAlign: "center",
  },
  P01_03_ButtonView: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    width: "60%",
    marginTop: 10 * kStyleConst.kSpacing,
  },
  P01_03_ButtonViewSmall: {
    flexDirection: "column-reverse",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: 10 * kStyleConst.kSpacing,
  },
  P01_03_SendButton: { width: 200, borderWidth: 0, backgroundColor: kColors.brandGreen },
  P01_03_CancelButtonText: { color: kColors.brandDarkGreen },
  P01_03_CancelButton: {
    borderColor: kColors.brandDarkGreen,
    width: 200,
  },
  P01_03_EmailView: {
    marginTop: 6 * kStyleConst.kSpacing,
    marginBottom: 16,
    width: "60%",
  },
  P01_03_EmailViewSmall: {
    alignSelf: "stretch",
    marginTop: 6 * kStyleConst.kSpacing,
    marginBottom: 16,
  },
  P01_04_ButtonView: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-end",
    width: "60%",
    flexWrap: "wrap",
    marginTop: 10 * kStyleConst.kSpacing,
  },
  P01_04_ButtonViewSmall: {
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    marginTop: 10 * kStyleConst.kSpacing,
  },
  P01_05_DescriptionText: {
    ...kFonts.bodyMedium,
    textAlign: "center",
  },
  P01_05_EmailText: {
    ...kFonts.bodyLight,
    marginTop: 4 * kStyleConst.kSpacing,
    color: kColors.black,
  },
  P01_06_NavigationButton: {
    marginTop: 6 * kStyleConst.kSpacing,
    width: 200,
    borderWidth: 0,
    backgroundColor: kColors.brandGreen,
  },
  P01_ButtonText: {
    color: kColors.white,
  },
  P01_ButtonStyle: {
    width: 150,
    borderWidth: 0,
    backgroundColor: kColors.brandGreen,
  },
  P01_ButtonView: {
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 6 * kStyleConst.kSpacing,
  },
  P01_ButtonViewSmall: {
    alignItems: "center",
    flexDirection: "column-reverse",
    justifyContent: "space-between",
    marginTop: 6 * kStyleConst.kSpacing,
  },
  P01_ApplyButton: {
    borderColor: kColors.brandDarkGreen,
    width: 250,
  },
  P01_ForgotPasswordText: {
    ...kFonts.clickable,
  },
  P01_ForgotPasswordView: {
    justifyContent: "center",
  },
  P01_LoginTextView: {
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
  },
  P02_ContentView: {
    flex: 1,
    paddingHorizontal: kStyleConst.kDashboardHorizontalPadding,
    paddingVertical: kStyleConst.kDashboardVerticalPadding,
  },
  P02_EyebrowView: {
    borderTopWidth: 1,
    borderTopColor: kColors.brandDarkGreen,
    marginBottom: kStyleConst.kSpacing * 9,
    maxWidth: kStyleConst.kDashboardEyebrowsMaxWidth,
    width: "100%",
  },
  P02_ImageBackground: {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: -1,
  },
  P02_Header: {
    color: kColors.darkGray,
    marginBottom: 16,
  },
  P02_Subheader: {
    letterSpacing: 1,
    marginBottom: 16,
  },
  P02_WrapTextAroundImage: {
    width: "75%",
  },
  P08_productNameImg: {
    alignItems: "center",
    flex: 1,
    flexDirection: "row",
  },
  P08_productThumbnail: {
    ...kStyleConst.kListProductImageThumbnail,
    marginEnd: kStyleConst.kSpacing * 2,
  },
  P08_01_Input: {
    borderBottomWidth: 1,
    borderColor: kColors.brandPink,
    borderRadius: 2,
    flex: 1,
    height: 36,
    marginTop: kStyleConst.kSpacing,
    outlineColor: kColors.transparent,
    paddingLeft: kStyleConst.kSpacing,
    paddingVertical: 2 * kStyleConst.kSpacing,
  },
  P08_01_TextInputGrow: {
    borderBottomWidth: 1,
    borderColor: kColors.brandPink,
    borderRadius: 2,
    marginTop: kStyleConst.kSpacing,
    outlineColor: kColors.transparent,
    paddingLeft: kStyleConst.kSpacing,
    paddingVertical: 2 * kStyleConst.kSpacing,
  },
  noTagTextInput: {
    borderBottomWidth: 1,
    borderColor: kColors.brandPink,
    borderRadius: 2,
    flex: 1,
    height: kStyleConst.kSubHeaderHeight,
    marginTop: kStyleConst.kSpacing,
    outlineColor: kColors.transparent,
    paddingLeft: kStyleConst.kSpacing,
    paddingVertical: 2 * kStyleConst.kSpacing,
  },
  withTagTextInput: {
    borderBottomWidth: 1,
    borderColor: kColors.brandPink,
    borderRadius: 2,
    flex: 1,
    height: kStyleConst.kSubHeaderHeight,
    marginTop: kStyleConst.kSpacing,
    outlineColor: kColors.transparent,
    paddingLeft: kStyleConst.kSpacing,
    paddingVertical: 2 * kStyleConst.kSpacing,
    paddingTop: kStyleConst.kSpacing - 1,
    paddingBottom: 2 * kStyleConst.kSpacing,
  },
  P08_PageHeader: {
    marginBottom: kStyleConst.kSpacing * 4,
  },
  P08_RadioLabel: {
    fontSize: 14,
    fontFamily: "Poppins",
    fontWeight: "300",
  },
  P03_01_OrderName: {
    ...kFonts.header,
    marginEnd: kStyleConst.kSpacing * 3,
  },
  P03_01OrderTitleRightView: {
    alignItems: "flex-end",
  },
  P03_01UpDownButton: {
    ...kStyleConst.kPlusMinusButton,
  },
  P03_01NumberInput: {
    ...kStyleConst.kNumberInput,
    textAlign: "center",
  },
  P03_01TableView: {
    flex: 1,
    alignItems: "flex-start",
  },
  P03_01TableEndView: {
    flex: 1,
    alignItems: "flex-end",
  },
  gHeaderNavStoreManageButton: {
    marginBottom: 0,
    marginRight: 4 * kStyleConst.kSpacing,
  },
  gHeaderNavStoreManageButtonGreen: {
    alignSelf: "flex-end",
    marginBottom: 0,
    marginRight: 8 * kStyleConst.kSpacing,
    borderWidth: 0,
    backgroundColor: kColors.brandGreen,
  },
  P03_01TableStartView: {
    flex: 1,
    flexDirection: "row",
    alignSelf: "flex-start",
  },
  P03_01TableContainer: {
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 3 * kStyleConst.kSpacing,
  },
  P03_01TableDetailsView: {
    flex: 3,
    alignItems: "flex-start",
  },
  P03_01TableQuantityView: {
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
  },
  P03_01TableQuantityViewContainer: {
    flex: 1,
    flexDirection: "row",
    alignContent: "flex-start",
  },
  P03_01OrderTableView: {
    backgroundColor: kColors.white,
    flexGrow: 1,
    paddingBottom: 3 * kStyleConst.kSpacing,
    marginHorizontal: 9 * kStyleConst.kSpacing,
    marginTop: 11 * kStyleConst.kSpacing,
    borderBottomColor: kColors.brandPink,
    borderBottomWidth: 2,
  },
  P03_01OrderTopView: {
    alignItems: "center",
    flexDirection: "row",
    paddingBottom: 2 * kStyleConst.kSpacing,
    justifyContent: "space-between",
    marginTop: 6 * kStyleConst.kSpacing,
    borderBottomColor: kColors.brandPink,
    borderBottomWidth: 2,
  },
  P03_01OrderTitleView: {
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "space-between",
    marginHorizontal: 9 * kStyleConst.kSpacing,
  },
  P03_01OrderTitleLeftView: {
    marginHorizontal: 9 * kStyleConst.kSpacing,
    marginVertical: 9 * kStyleConst.kSpacing,
  },
  P03_01OrderFlatList: {
    backgroundColor: kColors.green,
  },
  P03_01OrderFlatListContent: {
    justifyContent: "space-between",
    flexDirection: "row",
    backgroundColor: kColors.red,
    marginTop: 3 * kStyleConst.kSpacing,
  },
  P03_01OrderTitleLeftSubView: {
    flexDirection: "row",
    alignItems: "center",
  },
  P03_01OrderLogView: {
    borderTopWidth: 2,
    borderTopColor: kColors.brandPink,
  },
  P03_01OrderStatusCircleGreen: {
    ...kStyleConst.kOrderStatusDot,
    marginRight: 2 * kStyleConst.kSpacing,
    alignSelf: "center",
    backgroundColor: kColors.green,
    borderRadius: 16 / 2,
  },
  P03_01OrderStatusCircleRed: {
    ...kStyleConst.kOrderStatusDot,
    marginRight: 2 * kStyleConst.kSpacing,
    alignSelf: "center",
    backgroundColor: kColors.red,
    borderRadius: 16 / 2,
  },
  P03_01OrderTotalSubContainer: {
    marginTop: 5 * kStyleConst.kSpacing,
    alignItems: "flex-end",
  },
  P03_01OrderTotalContainer: {
    flexGrow: 1,
    minWidth: 400,
    flexWrap: "wrap",
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  P03_01OrderTotal: {
    alignItems: "flex-end",
    marginTop: 5 * kStyleConst.kSpacing,
    paddingTop: 5 * kStyleConst.kSpacing,
    borderTopWidth: 2,
    borderTopColor: kColors.brandPink,
  },
  P03_01OrderFlatListContainer: {
    borderTopWidth: 2,
    borderTopColor: kColors.brandPink,
    borderBottomWidth: 2,
    borderBottomColor: kColors.brandPink,
    paddingTop: 2 * kStyleConst.kSpacing,
    paddingBottom: 5 * kStyleConst.kSpacing,
  },
  P03_01OrderContainer: {
    backgroundColor: kColors.white,
  },
  P03_01OrderInnerContainer: {
    paddingVertical: 9 * kStyleConst.kSpacing,
  },
  P03_01OrderBottomContainer: {
    marginTop: 6 * kStyleConst.kSpacing,
    backgroundColor: kColors.white,
  },
  P03_01ODetailsContainer: {
    marginHorizontal: 9 * kStyleConst.kSpacing,
    marginVertical: 5 * kStyleConst.kSpacing,
  },
  P03_01ButtonContainer: {
    marginHorizontal: 9 * kStyleConst.kSpacing,
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  P03_01ButtonContainerAdmin: {
    marginTop: 8 * kStyleConst.kSpacing,
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  P03_01ButtonSaveContainer: {
    marginVertical: 9 * kStyleConst.kSpacing,
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  P03_01AddressShippingContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    maxWidth: 300,
  },
  P03_01AddressShippingContainerAccepted: {
    flexDirection: "row",
    justifyContent: "space-between",
    maxWidth: 750,
  },
  P04_01_ChatContainer: {
    flex: 1,
    marginHorizontal: kStyleConst.kSpacing,
    marginBottom: kStyleConst.kSpacing,
  },
  P04_MessageItemTitle: {
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: kStyleConst.kSpacing,
  },
  P04_SendButton: {
    backgroundColor: kColors.brandGreen,
    paddingHorizontal: kStyleConst.kSpacing * 3,
    paddingVertical: kStyleConst.kSpacing,
    borderRadius: kStyleConst.kBorderRadius,
  },
  P04_SendButtonDisabled: {
    backgroundColor: kColors.brandGreen,
    paddingHorizontal: kStyleConst.kSpacing * 3,
    paddingVertical: kStyleConst.kSpacing,
    borderRadius: kStyleConst.kBorderRadius,
    opacity: 0.75,
  },
  P04_SendButtonText: {
    ...kFonts.body,
    color: kColors.white,
  },
  gLoadingView: {
    alignItems: "center",
    flex: 1,
    justifyContent: "center",
  },
  gAlignItemsCenter: {
    alignItems: "center",
  },
  gLinkBankInput: {
    borderBottomWidth: 1,
    borderColor: kColors.brandPink,
    borderRadius: 2,
    flex: 1,
    height: 36,
    marginTop: 5,
    minWidth: kStyleConst.kApplyMinWidth,
    outlineColor: kColors.transparent,
    paddingVertical: 2 * kStyleConst.kSpacing,
    paddingLeft: kStyleConst.kSpacing,
    marginLeft: 0,
  },
  gLinkBankInputTiny: {
    borderBottomWidth: 1,
    borderColor: kColors.brandPink,
    borderRadius: 2,
    width: 70,
    height: 36,
    marginTop: 5,
    outlineColor: kColors.transparent,
    paddingVertical: 2 * kStyleConst.kSpacing,
    paddingLeft: kStyleConst.kSpacing,
  },
  gLinkBankInputGray: {
    borderBottomWidth: 1,
    borderColor: kColors.brandPink,
    borderRadius: 2,
    flex: 1,
    height: 36,
    marginTop: 5,
    minWidth: kStyleConst.kApplyMinWidth,
    outlineColor: kColors.transparent,
    paddingVertical: 2 * kStyleConst.kSpacing,
    paddingLeft: kStyleConst.kSpacing,
    color: kColors.mediumGrey,
  },
  gLinkBankInputBox: {
    borderColor: kColors.brandPink,
    borderRadius: 2,
    borderWidth: 1,
    flex: 1,
    height: kStyleConst.kApplicationNotesBoxHeight,
    marginTop: 5,
    minWidth: kStyleConst.kApplyMinWidth,
    outlineColor: kColors.transparent,
    outlineWidth: 0,
    paddingLeft: 2 * kStyleConst.kSpacing,
    paddingVertical: 2 * kStyleConst.kSpacing,
  },
  mPromoModalDescription: {
    borderColor: kColors.brandPink,
    borderRadius: 2,
    borderWidth: 1,
    flex: 1,
    height: kStyleConst.kPromoDescriptionBoxHeight,
    marginTop: 5,
    minWidth: kStyleConst.kApplyMinWidth,
    outlineColor: kColors.transparent,
    outlineWidth: 0,
    paddingLeft: 2 * kStyleConst.kSpacing,
    paddingVertical: 2 * kStyleConst.kSpacing,
  },
  P03_03OrderCommentBox: {
    borderColor: kColors.brandPink,
    borderRadius: 2,
    borderWidth: 1,
    flex: 1,
    height: kStyleConst.kApplicationNotesBoxHeight,
    marginTop: 5,
    minWidth: 400,
    outlineColor: kColors.transparent,
    outlineWidth: 0,
    paddingLeft: 2 * kStyleConst.kSpacing,
    paddingVertical: 2 * kStyleConst.kSpacing,
  },
  gLinkBankTripleInput: {
    borderBottomWidth: 1,
    borderColor: kColors.brandPink,
    borderRadius: 2,
    flex: 1,
    height: 36,
    marginTop: 5,
    minWidth: kStyleConst.kApplyMinWidth,
    paddingVertical: 2 * kStyleConst.kSpacing,
  },
  gLinkBankFormItem: {
    flexGrow: 1,
    marginBottom: 3 * kStyleConst.kSpacing,
    marginRight: 8 * kStyleConst.kSpacing,
    marginTop: 6 * kStyleConst.kSpacing,
  },
  gLinkBankFormItemNoRightMargin: {
    flexGrow: 1,
    marginBottom: 3 * kStyleConst.kSpacing,
    marginTop: 6 * kStyleConst.kSpacing,
  },
  gLinkBankFormItemNoRightTopMargin: {
    flexGrow: 1,
    marginBottom: 3 * kStyleConst.kSpacing,
  },
  gLinkBankFormItemNoBottomMargin: {
    flexGrow: 1,
    marginRight: 8 * kStyleConst.kSpacing,
    marginTop: 6 * kStyleConst.kSpacing,
  },
  gLinkBankFormItemNoTopMargin: {
    flexGrow: 1,
    marginBottom: 3 * kStyleConst.kSpacing,
    marginRight: 8 * kStyleConst.kSpacing,
  },
  gLinkBankFormItemZIndex: {
    minWidth: kStyleConst.kApplyMinWidth,
    marginBottom: 3 * kStyleConst.kSpacing,
    marginRight: 8 * kStyleConst.kSpacing,
    marginTop: 6 * kStyleConst.kSpacing,
    zIndex: 100000,
    flex: 1,
  },
  gLinkBankFormItemNoMargin: {
    flexGrow: 1,
    marginBottom: 3 * kStyleConst.kSpacing,
    marginTop: 6 * kStyleConst.kSpacing,
  },
  gMultiCheckBoxContainer: {
    flexGrow: 1,
    marginBottom: 3 * kStyleConst.kSpacing,
  },
  gApplyMultiCheckBox: {
    alignItems: "center",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "flex-start",
  },
  gFlexGrow: {
    flexGrow: 1,
  },
  gFlexRow: {
    flexDirection: "row",
  },
  gFlexRowCentered: {
    flexDirection: "row",
    alignItems: "center",
    flex: 1,
  },
  gLinkBankFormItemNoMarginZIndex: {
    flex: 1,
    minWidth: kStyleConst.kApplyMinWidth,
    marginBottom: 3 * kStyleConst.kSpacing,
    marginTop: 6 * kStyleConst.kSpacing,
    zIndex: 10,
  },
  gLinkBankFormItemNoMarginZIndexSingle: {
    flexGrow: 1,
    minWidth: kStyleConst.kApplyMinWidth,
    marginBottom: 3 * kStyleConst.kSpacing,
    marginTop: 6 * kStyleConst.kSpacing,
    zIndex: 10,
  },
  gLinkBankFormItemYesNo: {
    flexDirection: "row",
    flexGrow: 1,
    flexWrap: "wrap",
    justifyContent: "space-between",
    marginBottom: 3 * kStyleConst.kSpacing,
    marginRight: 8 * kStyleConst.kSpacing,
    marginTop: 6 * kStyleConst.kSpacing,
  },

  gLinkBankFormItemBottomMargin: {
    flexGrow: 1,
    marginBottom: 3 * kStyleConst.kSpacing,
    marginTop: 6 * kStyleConst.kSpacing,
  },
  gLinkBankFormNoBottomMargin: {
    flexGrow: 1,
    marginTop: 6 * kStyleConst.kSpacing,
  },
  gTableBadgeContainer: {
    alignItems: "center",
    flex: 1,
    flexDirection: "row",
  },
  gTableDotView: {
    borderRadius: kStyleConst.kTableDotSizing / 2,
    backgroundColor: kColors.brandDarkTransparent,
    marginEnd: kStyleConst.kSpacing,
    height: kStyleConst.kTableDotSizing,
    width: kStyleConst.kTableDotSizing,
  },
  gTableSortArrow: {
    ...kStyleConst.kTableSortArrowSizing,
    marginLeft: 2 * kStyleConst.kSpacing,
  },
  gTableEmptyMessageView: {
    textAlign: "center",
    marginVertical: kStyleConst.kSpacing * 5,
  },
  gTableEmptyMessageText: {
    ...kFonts.bodyItalic,
    color: kColors.mediumGrey,
  },
  gTableProfileImage: {
    backgroundColor: kColors.lightMed,
    height: kStyleConst.kTableProfileImageDimension,
    width: kStyleConst.kTableProfileImageDimension,
    borderRadius: kStyleConst.kTableProfileImageDimension / 2,
    marginEnd: kStyleConst.kSpacing * 2,
  },
  P08_01_InputVariant: {
    borderBottomWidth: 1,
    borderColor: kColors.brandPink,
    borderRadius: 2,
    flexDirection: "row",
    flex: 1,
    height: 36,
    justifyContent: "flex-start",
    marginRight: kStyleConst.kSpacing * 2,
    marginTop: 5,
    paddingVertical: 2 * kStyleConst.kSpacing,
  },
  P08_01_InputVariantTester: {
    borderBottomWidth: 1,
    borderColor: kColors.brandPink,
    borderRadius: 2,
    flexDirection: "row",
    flex: 1,
    height: 27,
    justifyContent: "flex-start",
  },
  P08_01_InputProductName: {
    borderBottomWidth: 1,
    borderColor: kColors.brandPink,
    borderRadius: 2,
    flex: 1,
    height: 7 * kStyleConst.kSpacing,
    marginTop: 5,
    paddingVertical: kStyleConst.kSpacing,
  },
  P08_01_FormContainer: {
    marginBottom: 12 * kStyleConst.kSpacing,
  },
  applyUserFormContainer: {
    marginTop: 5 * kStyleConst.kSpacing,
  },
  gNumberInputView: {
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "row",
    overflow: "hidden",
  },
  gNumberInputTextInput: {
    flex: 1,
    minWidth: 0,
  },
  gNumberInputStartUnit: {
    marginEnd: kStyleConst.kSpacing,
  },
  gNumberInputEndUnit: {
    marginStart: kStyleConst.kSpacing,
  },
  gFormContainerUserInfo: {
    marginHorizontal: 13 * kStyleConst.kSpacing,
    marginBottom: 12 * kStyleConst.kSpacing,
    zIndex: 1,
  },
  gFormContainer: {
    marginHorizontal: 13 * kStyleConst.kSpacing,
    marginTop: 12 * kStyleConst.kSpacing,
    marginBottom: 12 * kStyleConst.kSpacing,
    zIndex: 1,
  },
  gFormContainerNoNav: {
    marginHorizontal: 13 * kStyleConst.kSpacing,
    marginBottom: 12 * kStyleConst.kSpacing,
    zIndex: 1,
  },
  P08_01_FormItem: {
    flex: 1,
    marginRight: 8 * kStyleConst.kSpacing,
  },
  P08_01_FormItemMobile: {
    flex: 1,
    marginBottom: 6 * kStyleConst.kSpacing,
  },
  P08_01_FormItemNoMargin: {
    flex: 1,
  },
  P08_01_CheckboxContainer: {
    alignItems: "center",
    flexDirection: "row",
    marginBottom: 3 * kStyleConst.kSpacing,
    marginTop: kStyleConst.kSpacing,
  },
  P08_01_CheckboxContainer2: {
    ...kFonts.formLegend,
    alignSelf: "center",
    flexDirection: "row",
    flex: 1,
    justifyContent: "flex-start",
    maxWidth: 60,
  },
  P08_01_InputHeader: {
    ...kFonts.formLegend,
  },
  inputHeaderLifestyleImage: {
    ...kFonts.formLegend,
    marginBottom: 2 * kStyleConst.kSpacing,
  },
  P08_01_InputHeaderMargin: {
    ...kFonts.formLegend,
    marginRight: 4,
  },
  P08_01_InputYesNoHeader: {
    ...kFonts.formLegend,
    marginBottom: 2 * kStyleConst.kSpacing,
  },
  P08_01_InputHeaderWrap: {
    flex: 1,
    flexWrap: "wrap",
    minWidth: kStyleConst.kApplyMinWidth,
    marginBottom: 2 * kStyleConst.kSpacing,
    flexDirection: "row",
    marginTop: 0,
  },
  P08_01_TesterContainer: {
    ...kFonts.formLegend,
    alignSelf: "center",
    flexDirection: "row",
    flex: 1,
    justifyContent: "flex-start",
    marginRight: kStyleConst.kSpacing * 2,
  },
  P08_01_ImageVariant: {
    alignSelf: "center",
    flexDirection: "row",
    justifyContent: "flex-start",
    marginHorizontal: kStyleConst.kSpacing * 2,
    maxWidth: 57 + kStyleConst.kSpacing * 2,
  },
  P08_01_FormRow: {
    alignItems: "flex-start",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
    marginBottom: 3 * kStyleConst.kSpacing,
  },
  P08_01_FormRowMobile: {
    flexDirection: "column",
    flexWrap: "wrap",
    justifyContent: "space-between",
    marginBottom: 3 * kStyleConst.kSpacing,
  },
  gApplyYesNoTextRight: {
    marginRight: 3 * kStyleConst.kSpacing,
  },
  gApplyCheckMark2BoxTextLeft: {
    marginRight: 3 * kStyleConst.kSpacing,
  },
  gApplyCheckMark2BoxNoMargin: {
    ...kStyleConst.kCheckBox,
  },
  gCheckMark2Box: {
    ...kStyleConst.kCheckBox,
    marginRight: 7 * kStyleConst.kSpacing,
  },
  gApplyYesNoMultiCheckBox: {
    ...kStyleConst.kCheckBox,
    marginRight: 2 * kStyleConst.kSpacing,
  },
  gFormRow: {
    alignItems: "flex-start",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
    marginBottom: 3 * kStyleConst.kSpacing,
    minWidth: 300,
  },
  gFormRowNoMarginLeft: {
    alignItems: "flex-start",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
    marginBottom: 3 * kStyleConst.kSpacing,
    marginLeft: 0,
    minWidth: 300,
  },
  gFormRowNoMargin: {
    alignItems: "flex-start",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
    minWidth: kStyleConst.kApplyMinWidth,
  },
  gFormRowNoMarginValidatedSingle: {
    flexWrap: "wrap",
    justifyContent: "space-between",
    minWidth: kStyleConst.kApplyMinWidth,
    flexGrow: 1,
    marginBottom: 3 * kStyleConst.kSpacing,
    marginTop: 6 * kStyleConst.kSpacing,
  },
  gFormRowNoMarginSingle: {
    flexWrap: "wrap",
    justifyContent: "space-between",
    minWidth: kStyleConst.kApplyMinWidth,
    flexGrow: 1,
    marginBottom: 3 * kStyleConst.kSpacing,
    marginTop: 6 * kStyleConst.kSpacing,
  },
  gAlignItems: {
    alignItems: "flex-start",
  },
  P03_01OrderCommentView: {
    flexGrow: 1,
    alignItems: "flex-start",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
    maxWidth: 550,
  },
  gFormRowNoMarginZIndex: {
    alignItems: "flex-start",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
    minWidth: kStyleConst.kApplyMinWidth,
    zIndex: 10,
  },
  gFormRowNoMarginBottom: {
    alignContent: "center",
    alignItems: "center",
    marginTop: 13 * kStyleConst.kSpacing,
  },
  P08_01_FormRowNoMargin: {
    alignItems: "flex-start",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  P08_01_VariantFormArea: {
    borderLeftColor: kColors.brandPink,
    borderLeftWidth: 1,
    flex: 1,
    paddingLeft: 8 * kStyleConst.kSpacing,
  },
  P08_01_VariantContainer: {
    flexDirection: "row",
    marginBottom: 6 * kStyleConst.kSpacing,
  },
  P08_01_VariantImageWrapper: {
    alignItems: "center",
    backgroundColor: kColors.backgroundGrey,
    flexDirection: "column",
    height: 57,
    justifyContent: "center",
  },
  P08_01_VariantImage: {
    height: 57,
    width: 57,
  },
  P08_01_VariantTesterBox: {
    alignItems: "baseline",
    justifyContent: "center",
    width: 44,
  },
  P08_01_VariantImageHeader: {
    width: 57 + kStyleConst.kSpacing * 2 + 10,
  },
  P08_01_InputStretch: {
    width: "100%",
  },
  P08_01_VariantIndexArea: {
    width: 9 * kStyleConst.kSpacing,
  },
  P08_01_AddVariantButton: {
    ...kStyleConst.kAddVariantButtonDimensions,
    alignItems: "center",
    backgroundColor: kColors.brandGreen,
    justifyContent: "center",
  },
  P08_01_DELETEButton: {
    ...kStyleConst.kStandardButtons,
    alignItems: "center",
    borderColor: kColors.secondaryRed,
    borderRadius: 2,
    borderWidth: 2,
    justifyContent: "center",
    marginBottom: kStyleConst.kSpacing,
  },
  P03_01_DECLINEButton: {
    ...kStyleConst.kStandardButtons,
    alignItems: "center",
    borderColor: kColors.secondaryRed,
    borderRadius: 2,
    borderWidth: 2,
    justifyContent: "center",
    marginRight: 2 * kStyleConst.kSpacing,
  },
  P08_01_PublishButton: {
    ...kStyleConst.kStandardButtons,
    alignItems: "center",
    backgroundColor: kColors.brandGreen,
    borderRadius: 2,
    justifyContent: "center",
  },
  P08_01_SaveButton: {
    marginLeft: 4 * kStyleConst.kSpacing,
    ...kStyleConst.kStandardButtons,
    alignItems: "center",
    borderColor: kColors.black,
    borderRadius: 2,
    borderWidth: 2,
    justifyContent: "center",
  },
  P08_01_RightBottomButtonView: {
    flexDirection: "row",
  },
  P08_01_VariantDescription: {
    flex: 2,
    marginRight: 8 * kStyleConst.kSpacing,
  },
  P05_01_Footer: {
    alignItems: "flex-start",
    flexDirection: "row",
    justifyContent: "flex-end",
    marginTop: 30,
  },
  P05_02_Footer: {
    alignItems: "flex-start",
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 30,
  },
  P05_PromotionModalWidth: {
    width: 20,
  },
  P06ContentContainer: {
    backgroundColor: kColors.white,
    flexDirection: "column",
    flexGrow: 1,
  },
  P03_01ContentContainer: {
    backgroundColor: kColors.brandLight,
    flexDirection: "column",
    flexGrow: 1,
  },
  P06PageNumber: {
    alignSelf: "center",
    marginRight: 3 * kStyleConst.kSpacing,
  },
  P06_05_HeaderText: {
    ...kFonts.profileHeader,
    color: kColors.black,
    marginLeft: 2 * kStyleConst.kSpacing,
    marginBottom: 2 * kStyleConst.kSpacing,
  },
  P06_06_RepButton: {
    backgroundColor: kColors.brandGreen,
    width: 250,
    marginTop: 12 * kStyleConst.kSpacing,
  },
  P06_06_RepButtonText: {
    color: kColors.white,
  },
  P06ScrollView: {
    backgroundColor: kColors.white,
    flexGrow: 1,
  },
  P06_ModalBackground: {
    alignItems: "center",
    backgroundColor: kColors.transparentBlack,
    bottom: 0,
    justifyContent: "center",
    left: 0,
    paddingHorizontal: 50 * kStyleConst.kSpacing,
    paddingTop: 4 * kStyleConst.kSpacing,
    position: "absolute",
    right: 0,
    top: 0,
    zIndex: 15,
  },
  P06_ModalContainer: {
    alignItems: "stretch",
    backgroundColor: kColors.white,
    flexDirection: "column",
    paddingTop: 10 * kStyleConst.kSpacing,
    paddingHorizontal: 10 * kStyleConst.kSpacing,
    paddingBottom: 6 * kStyleConst.kSpacing,
    zIndex: 1,
  },
  P06_ModalEmailArea: {
    alignItems: "center",
    flexDirection: "row",
    marginTop: 3 * kStyleConst.kSpacing,
  },
  P06_ModalHeader: {
    alignItems: "flex-start",
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 3 * kStyleConst.kSpacing,
  },
  P06_ModalInput: {
    borderColor: kColors.lightMed,
    borderWidth: 1,
    outlineWidth: 0,
    flex: 1,
    padding: kStyleConst.kSpacing,
  },
  P06_ModalInputNoTags: {
    borderColor: kColors.lightMed,
    borderWidth: 1,
    outlineWidth: 0,
    flex: 1,
    padding: kStyleConst.kSpacing,
  },
  P06_ModalInputWithTags: {
    borderColor: kColors.lightMed,
    borderWidth: 1,
    outlineWidth: 0,
    flex: 1,
    paddingHorizontal: kStyleConst.kSpacing,
    paddingVertical: 2,
  },
  P06_ModalNoteArea: {
    alignItems: "flex-start",
    flexDirection: "row",
    marginTop: 3 * kStyleConst.kSpacing,
  },
  P06_ModalSendButton: {
    alignItems: "center",
    backgroundColor: kColors.brandGreen,
    justifyContent: "center",
    padding: 3 * kStyleConst.kSpacing,
    width: 230,
  },
  P06_ModalSendButtonArea: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 3 * kStyleConst.kSpacing,
  },
  P06_InputToolbarView: {
    borderWidth: kStyleConst.kBorderWidth,
    borderTopColor: kColors.brandPink,
    borderColor: kColors.transparent,
    height: kStyleConst.kMessageInputHeight,
    paddingHorizontal: 2 * kStyleConst.kSpacing,
  },
  P06_InputToolbarSendBar: {
    alignItems: "center",
    flexDirection: "row",
  },
  P06_InputToolbarTextInput: {
    flex: 1,
    paddingVertical: 2 * kStyleConst.kSpacing,
    outlineWidth: 0,
  },
  P06_InputToolbarInstructionTextView: {
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  P06_InputToolbarInstructionText: {
    ...kFonts.bodySmall,
  },
  P06_InputToolbarInstructionTextBold: {
    ...kFonts.bodySmall,
    fontWeight: "bold",
  },
  P09_01_Avatar: {
    borderRadius: 50,
    height: 100,
    marginBottom: 3 * kStyleConst.kSpacing,
    marginTop: 10 * kStyleConst.kSpacing,
    width: 100,
  },
  P09_01_AvatarView: {
    flexDirection: "column",
  },
  P09_01_BrandDescriptionView: {
    alignItems: "center",
    alignSelf: "flex-start",
    flex: 1,
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "flex-end",
    marginLeft: 6 * kStyleConst.kSpacing,
    minWidth: 300,
  },
  P09_01_BrandDot: {
    backgroundColor: kColors.brandCoral,
    borderRadius: 3.5,
    height: 7,
    marginHorizontal: 10,
    width: 7,
  },
  P09_01_BrandStoryText: {
    ...kFonts.body,
    maxWidth: 800,
    minWidth: 300,
    textAlign: "right",
  },
  P09_01_BrandText: {
    ...kFonts.profileHeader,
    color: kColors.black,
  },
  P09_01_BrandTextView: {
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  P09_01_ButtonDeactivate: {
    alignItems: "center",
    backgroundColor: kColors.white,
    borderColor: kColors.secondaryRed,
    borderRadius: kStyleConst.kBorderRadius,
    borderWidth: 2,
    flexDirection: "row",
    height: 40,
    justifyContent: "center",
    paddingHorizontal: 6 * kStyleConst.kSpacing,
  },
  P09_01_ButtonDeactivateText: {
    color: kColors.secondaryRed,
  },
  P09_01_ButtonLinks: {
    height: 25,
    width: 25,
  },
  P09_01_ButtonSave: {
    alignItems: "center",
    alignSelf: "flex-end",
    borderColor: kColors.black,
    borderRadius: 2,
    borderWidth: 1,
    height: 40,
    justifyContent: "center",
    marginTop: 12 * kStyleConst.kSpacing,
    width: 150,
  },
  P09_01_ButtonSaveDisabled: {
    alignItems: "center",
    alignSelf: "flex-end",
    borderColor: kColors.black,
    borderRadius: 2,
    borderWidth: 1,
    height: 40,
    justifyContent: "center",
    marginTop: 12 * kStyleConst.kSpacing,
    opacity: 0.5,
    width: 150,
  },
  P09_01_ButtonTOS: {
    alignItems: "center",
    backgroundColor: kColors.brandGreen,
    borderRadius: kStyleConst.kBorderRadius,
    flexDirection: "row",
    height: 40,
    justifyContent: "center",
    paddingHorizontal: 6 * kStyleConst.kSpacing,
  },
  P09_01_ButtonTOSDisabled: {
    alignItems: "center",
    backgroundColor: kColors.brandGreen,
    borderRadius: kStyleConst.kBorderRadius,
    flexDirection: "row",
    height: 40,
    justifyContent: "center",
    opacity: 0.5,
    paddingHorizontal: 6 * kStyleConst.kSpacing,
  },
  P09_01_ButtonTOSText: {
    color: kColors.white,
  },
  P09_01_ButtonsView: {
    alignItems: "center",
    flexDirection: "row-reverse",
    justifyContent: "space-between",
    marginTop: 12 * kStyleConst.kSpacing,
    marginBottom: 6 * kStyleConst.kSpacing,
  },
  P09_01_ButtonsRightView: {
    width: 300,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  P09_01_CategoryText: {
    ...kFonts.bodyLight,
    color: kColors.black,
  },
  P09_01_ClearRep: {
    height: 15,
    width: 15,
  },
  gConfirmModal: {
    backgroundColor: kColors.white,
    zIndex: 10,
    paddingHorizontal: kStyleConst.kSpacing * 4,
    paddingTop: kStyleConst.kSpacing * 4,
  },
  gConfirmModalTitle: {
    ...kFonts.modalText,
    marginBottom: kStyleConst.kSpacing * 3,
  },
  gConfirmModalCancel: {
    borderColor: kColors.brandGreen,
  },
  gConfirmModalCancelText: {
    color: kColors.brandGreen,
  },
  gDropDownIcon: {
    ...kStyleConst.kDropDownIcon,
  },
  gDropDownIconDisabled: {
    ...kStyleConst.kDropDownIcon,
    opacity: 0.25,
  },
  gDropDownRow: {
    flexDirection: "row",
    flex: 1,
    paddingVertical: kStyleConst.kSpacing * 2,
    zIndex: 0,
  },
  P09_01_ClearRepButton: {
    height: 15,
    marginBottom: 3,
    width: 15,
  },
  P09_01_ConnectionDataText: {
    ...kFonts.formLegend,
    color: kColors.black,
  },
  P09_01_ConnectionInputLeft: {
    flex: 1,
    marginRight: 4 * kStyleConst.kSpacing,
  },
  P09_01_ConnectionInputRight: {
    flex: 1,
    marginLeft: 4 * kStyleConst.kSpacing,
  },
  P09_01_ConnectionTermsText: {
    ...kFonts.profileHeader,
    color: kColors.black,
  },
  P09_01_ConnectionTextInput: {
    borderBottomWidth: 1,
    borderColor: kColors.brandPink,
    flex: 1,
    marginTop: 4 * kStyleConst.kSpacing,
    outlineColor: kColors.transparent,
    paddingBottom: 2,
  },
  P09_01_ConnectionTextInputNoUnderline: {
    flex: 1,
    marginBottom: 2,
    marginTop: 4 * kStyleConst.kSpacing,
    outlineColor: kColors.transparent,
  },
  P09_01_ConnectionNumberInput: {
    flex: 1,
    outlineColor: kColors.transparent,
  },
  P09_01_LinkView: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: kStyleConst.kSpacing + 3,
    width: 60,
  },
  P09_01_LocationText: {
    ...kFonts.bodyLight,
    color: kColors.black,
    marginTop: kStyleConst.kSpacing,
  },
  P09_01_MinOrderCheckBoxStyle: {
    marginLeft: -10,
    marginRight: 2 * kStyleConst.kSpacing,
  },
  P09_01_MinOrderCheckBoxView: {
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "flex-start",
    marginLeft: 0,
    marginTop: 9 * kStyleConst.kSpacing,
  },
  P09_01_PercentageView: {
    alignItems: "center",
    borderBottomWidth: 1,
    borderColor: kColors.brandPink,
    flexDirection: "row",
    flex: 1,
    justifyContent: "flex-start",
    marginTop: 4 * kStyleConst.kSpacing,
    paddingBottom: 2,
  },
  P09_01_PublicDataView: {
    alignItems: "center",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
  },
  P09_01_RepEmailInput: {
    alignItems: "flex-end",
    borderBottomWidth: 1,
    borderColor: kColors.brandPink,
    flexDirection: "row",
    justifyContent: "space-between",
  },
  P09_01_RetailNumberInput: { borderBottomWidth: 1, borderColor: kColors.brandPink, marginTop: 20, paddingBottom: 2 },
  P09_01_RetailSaveDataRow: { flexDirection: "row", flexWrap: "wrap", marginTop: 30 },
  P09_01_RetailSaveDataView: {
    backgroundColor: kColors.white,
    marginRight: 30,
    paddingBottom: 100,
    paddingHorizontal: 30,
    paddingTop: 50,
  },
  P09_01_Screen: {
    backgroundColor: kColors.white,
    flex: 1,
    paddingHorizontal: 6 * kStyleConst.kSpacing,
  },
  P09_01_FullScreen: { flex: 1, backgroundColor: kColors.brandLight },
  P09_01_ScreenNoHeight: {
    backgroundColor: kColors.white,
    marginRight: 6 * kStyleConst.kSpacing,
    paddingBottom: 6 * kStyleConst.kSpacing,
    paddingHorizontal: 6 * kStyleConst.kSpacing,
  },
  P09_01_TableView: {
    marginTop: 12 * kStyleConst.kSpacing,
  },
  P09_AbsoluteImport: {
    ...kStyleConst.kImportSmall,
    alignSelf: "center",
    marginLeft: 3 * kStyleConst.kSpacing,
  },
  P09_ProductAbsoluteImport: {
    ...kStyleConst.kImportBig,
    alignSelf: "center",
    marginLeft: kStyleConst.kSpacing * 2,
  },
  P09_ProductAbsoluteImportFlipped: {
    ...kStyleConst.kImportBig,
    alignSelf: "center",
    marginLeft: kStyleConst.kSpacing * 2,
    transform: [{ rotate: "180deg" }],
  },
  P09_AbsoluteLifeImport: {
    ...kStyleConst.kImportBig,
    bottom: -(kStyleConst.kSpacing * 2),
    position: "absolute",
    right: 0,
  },
  P09_Banner: {
    alignItems: "center",
    backgroundColor: kColors.backgroundGrey,
    flexDirection: "column",
    height: kStyleConst.kBannerHeight,
    justifyContent: "center",
    marginBottom: 141 / 2,
  },
  P09_BannerImage: {
    height: 197,
    width: "100%",
  },
  P09_CheckedArea: {
    alignItems: "center",
    minWidth: kStyleConst.kMinWidth,
  },
  P09_Column: {
    flexDirection: "column",
    flex: 1,
    flexWrap: "wrap",
    minWidth: kStyleConst.kMinWidth,
  },
  P09_DiscardAbsolute: {
    ...kStyleConst.kAddImageDiscardDimensions,
    position: "absolute",
    right: kStyleConst.kSpacing * 4,
    top: kStyleConst.kSpacing * 4,
    zIndex: 10,
  },
  P09_DiscardAbsoluteHeroImages: {
    ...kStyleConst.kAddImageDiscardDimensions,
    position: "absolute",
    right: kStyleConst.kSpacing,
    top: kStyleConst.kSpacing,
    zIndex: 11,
  },
  P09_DollarPadding: {
    paddingLeft: 20,
  },
  P09_DoubleShimmer: {
    borderColor: kColors.brandPink,
    borderWidth: 1,
    height: 165,
    width: "100%",
  },
  P09_DoubleText: {
    borderRadius: kStyleConst.kBorderRadius,
    flex: 1,
    height: 200,
    margin: 2,
    outlineColor: kColors.transparent,
    paddingHorizontal: kStyleConst.kSpacing * 2,
    paddingVertical: kStyleConst.kSpacing * 2,
  },
  P09_FormTitle: {
    ...kFonts.formLegend,
  },
  P03_01_FormTitle: {
    ...kFonts.formLegend,
    marginTop: 2 * kStyleConst.kSpacing,
  },
  P03_01_TotalTextStyle: {
    ...kFonts.formLegend,
    marginTop: 2 * kStyleConst.kSpacing,
    marginRight: 8 * kStyleConst.kSpacing,
  },
  P03_01_TotalTextStyleNoTopMargin: {
    ...kFonts.formLegend,
    marginRight: 8 * kStyleConst.kSpacing,
  },
  P03_01_FormTitleSub: {
    marginTop: 2 * kStyleConst.kSpacing,
  },
  P03_01_FormTitleSubAddress: {
    marginTop: 2 * kStyleConst.kSpacing,
    maxWidth: 150,
  },
  P03_01_OrderRetailMessageView: {
    marginTop: 2 * kStyleConst.kSpacing,
  },
  P09_GreenButton: {
    backgroundColor: kColors.brandDarkGreen,
    borderColor: kColors.brandDarkGreen,
    borderRadius: kStyleConst.kBorderRadius,
    borderWidth: kStyleConst.kBorderWidth,
    color: kColors.white,
    fontSize: 12,
    marginRight: 22,
    paddingVertical: kStyleConst.kSpacing * 2,
    textAlign: "center",
    textTransform: "uppercase",
    width: 150,
  },
  P09_ImageRound: {
    ...kStyleConst.kImageSelect,
    borderRadius: 360,
  },
  P09_ImageSquare: {
    ...kStyleConst.kImageSelect,
  },
  P09_ImageSelectRound: {
    ...kStyleConst.kImageSelect,
    alignItems: "center",
    backgroundColor: kColors.backgroundGrey,
    borderRadius: 360,
    flexDirection: "column",
    justifyContent: "center",
    marginTop: kStyleConst.kSpacing * 4,
  },
  P09_ImageSelectSquare: {
    ...kStyleConst.kImageSelect,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: kColors.backgroundGrey,
  },
  P09_ImageSelectSquarePrimary: {
    ...kStyleConst.kImageSelectPrimary,
    backgroundColor: kColors.backgroundGrey,
    margin: kStyleConst.kSpacing * 2,
  },
  P09_LegendStamp: {
    ...kStyleConst.kLegendStamp,
    marginHorizontal: kStyleConst.kSpacing * 2,
    marginVertical: 5,
  },
  P09_LifestyleImport: {
    ...kStyleConst.kImportBig,
    marginHorizontal: kStyleConst.kSpacing * 2,
    marginVertical: kStyleConst.kSpacing,
  },
  P09_PageContainer: {
    backgroundColor: kColors.white,
    flexGrow: 1,
    marginRight: 6 * kStyleConst.kSpacing,
    marginTop: 6 * kStyleConst.kSpacing,
    paddingHorizontal: 6 * kStyleConst.kSpacing,
  },
  P09_HeroImages: {
    backgroundColor: kColors.white,
    flexGrow: 1,
    flexWrap: "wrap",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: 6 * kStyleConst.kSpacing,
    padding: 6 * kStyleConst.kSpacing,
    marginRight: 6 * kStyleConst.kSpacing,
  },
  P09_ProfileImageContainer: {
    marginTop: kStyleConst.kSpacing * 2,
    width: kStyleConst.kImageSelect.width,
  },
  P09_ProfileImageContainerValid: {
    bottom: 10,
    left: 10,
    marginTop: kStyleConst.kSpacing * 2,
    position: "absolute",
    width: kStyleConst.kImageSelect.width,
  },

  P09_RepButton: {
    backgroundColor: kColors.brandDarkGreen,
    borderWidth: 0,
    width: 250,
  },
  P09_PromoButton: {
    backgroundColor: kColors.brandDarkGreen,
    borderWidth: 0,
    width: 150,
  },
  P09_RepButtonText: {
    color: kColors.white,
  },
  P09_RepButtonsView: {
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "space-between",
    marginVertical: 20 * kStyleConst.kSpacing,
  },
  P09_Row: {
    flexDirection: "row",
    flexWrap: "wrap",
    marginVertical: kStyleConst.kSpacing * 2,
    minWidth: kStyleConst.kMinWidth,
  },
  Test_Row: {
    alignItems: "center",
    flexDirection: "row",
    flexWrap: "wrap",
    marginVertical: kStyleConst.kSpacing * 2,
    minWidth: kStyleConst.kMinWidth,
  },
  P09_RowChild: {
    flex: 1,
  },
  P09_Scroll: {
    flex: 1,
  },
  P09_ScrollContentContainer: {
    alignItems: "center",
  },
  P09_SpaceBetween: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
    marginVertical: kStyleConst.kSpacing * 2,
    minWidth: kStyleConst.kMinWidth,
  },
  P09_Spacer: {
    width: 4 * kStyleConst.kSpacing,
  },
  P09_StackScreenDefault: {
    backgroundColor: kColors.brandLight,
    flex: 1,
  },
  P09_StackScreenDefaultPublicProfile: {
    backgroundColor: kColors.white,
    flex: 1,
    marginRight: 6 * kStyleConst.kSpacing,
  },
  P09_WhiteButton: {
    backgroundColor: kColors.white,
    borderRadius: kStyleConst.kBorderRadius,
    borderWidth: kStyleConst.kBorderWidth,
    color: kColors.black,
    fontSize: 12,
    paddingVertical: kStyleConst.kSpacing * 2,
    textAlign: "center",
    textTransform: "uppercase",
    width: 150,
  },
  P09_Wrap: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
    marginVertical: kStyleConst.kSpacing * 2,
  },
  P09_WrapNone: {
    flexWrap: "nowrap",
  },
  P09_ZTop: {
    zIndex: 10,
  },
  P09_ZeroTop: {
    marginTop: 0,
  },
  P10_Logo: {
    height: 55,
    width: 300,
  },
  P11_ReportTabContainer: {
    position: "relative",
    display: "flex",
    zIndex: 1000000000,
  },
  P11_ReportTabs: {
    position: "absolute",
    top: -kStyleConst.kSpacing * 8,
    left: kStyleConst.kSpacing * 14,
    right: kStyleConst.kSpacing * 2,
    height: kStyleConst.kSpacing * 8,
    zIndex: 100000000,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    overflow: "scroll",
  },
  P11_ReportTabItem: {
    width: kStyleConst.kSpacing * 20,
    height: kStyleConst.kSpacing * 8,
    backgroundColor: kColors.brandLight,
    borderTopRightRadius: kStyleConst.kSpacing * 5,
    borderTopLeftRadius: kStyleConst.kSpacing * 5,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  P11_ReportTabItemSelected: {
    backgroundColor: kColors.brandGreen,
  },
  P11_ReportTabTitle: {
    alignSelf: "flex-start",
    fontSize: 12,
    display: "flex",
    width: "100%",
    height: "100%",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    overflow: "hidden",
  },
  P11_ReportTabTitleSelected: {
    color: kColors.brandLight,
  },
  P12_BoutiqueInfoCell: {
    alignItems: "flex-start",
    flexDirection: "column",
  },
  P12_BoutiqueInfoContainer: {
    alignItems: "flex-start",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  P12_ButtonAccept: {
    alignItems: "center",
    backgroundColor: kColors.brandGreen,
    borderColor: kColors.brandGreen,
    borderWidth: 2,
    flex: 1,
    justifyContent: "center",
    padding: 15,
  },
  P12_ButtonArea: {
    alignItems: "flex-start",
    flex: 1,
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  P12_ButtonAreaDividerLeft: {
    alignItems: "stretch",
    flexDirection: "column",
    flex: 1,
  },
  P12_ButtonAreaDividerRight: {
    alignItems: "stretch",
    flexDirection: "column",
    flex: 1,
    marginLeft: 30,
  },
  P12_ButtonDecline: {
    alignItems: "center",
    borderColor: kColors.black,
    borderWidth: 2,
    flex: 1,
    justifyContent: "center",
    padding: 15,
  },
  P12_Container: {
    backgroundColor: kColors.white,
    padding: 70,
  },
  P12_HeaderContainer: {
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 30,
  },
  P12_Loading: {
    backgroundColor: kColors.white,
    bottom: 0,
    left: 0,
    opacity: 0.8,
    position: "absolute",
    right: 0,
    top: 0,
    zIndex: 10,
  },
  P12_MessageButton: {
    alignItems: "center",
    borderColor: kColors.black,
    borderWidth: 2,
    justifyContent: "center",
    padding: 15,
    width: 150,
  },
  P12_NoteBox: {
    borderColor: kColors.lightMed,
    borderWidth: 1,
    flexDirection: "column",
    flex: 1,
    marginRight: 30,
  },
  P12_SettingsBox: {
    borderColor: kColors.lightMed,
    borderWidth: 1,
    flexDirection: "column",
    flex: 1,
    marginTop: 30,
  },
  P12_SettingsBoxBodyContainer: {
    borderColor: kColors.lightMed,
    borderTopWidth: 1,
    padding: 15,
  },
  P12_SettingsBoxHeader: {
    alignItems: "center",
    backgroundColor: kColors.VeryLightGrey,
    flexDirection: "row",
    padding: 15,
  },
  P12_SettingsBoxLarge: {
    borderColor: kColors.lightMed,
    borderWidth: 1,
    flexDirection: "column",
    flex: 1,
    marginLeft: 30,
    marginTop: 30,
  },
  P12_SettingsContainer: {
    alignItems: "stretch",
    flexDirection: "row",
    marginTop: 30,
  },
  P12_SettingsLeftSideContainer: {
    flexDirection: "column",
    flex: 1,
    justifyContent: "space-between",
  },
  P12_ShippingAccountInfo: {
    alignSelf: "flex-end",
  },
  P12_ShippingAccountInput: {
    alignSelf: "stretch",
    marginVertical: 15,
  },
  P12_ShippingPercentContainer: {
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 15,
  },
  P12_ShippingPercentInput: {
    width: 115,
  },
  P12_ShippingPercentInputArea: {
    alignItems: "center",
    flexDirection: "row",
  },
  P99_BrandCardContainer: {
    minWidth: 300,
    maxWidth: 500,
    flex: 1,
    height: 537,
    marginLeft: 5 * kStyleConst.kSpacing,
    marginBottom: 14 * kStyleConst.kSpacing,
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "stretch",
  },

  P99_BrandCardContainerMobile: {
    minWidth: 300,
    maxWidth: 500,
    flex: 1,
    height: 537,
    marginBottom: 14 * kStyleConst.kSpacing,
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "stretch",
  },
  P99_SubcategoryContainer: {
    paddingLeft: 3 * kStyleConst.kSpacing,
  },
  P99_Container: {
    marginHorizontal: 24 * kStyleConst.kSpacing,
    justifyContent: "center",
  },
  P99_ContainerMobile: {
    marginHorizontal: 4 * kStyleConst.kSpacing,
    justifyContent: "center",
  },
  P99_ListContainer: {
    flexDirection: "row",
    flex: 1,
    flexWrap: "wrap",
  },
  P99_ContentContainer: {
    flexDirection: "row",
  },
  P99_ContentContainerMobile: {
    flexDirection: "column",
  },
  P99_SearchBox: {
    flex: 3,
    marginLeft: 50 * kStyleConst.kSpacing,
    marginVertical: 10 * kStyleConst.kSpacing,
  },
  P99_PageHeaderMobile: {
    marginVertical: 10 * kStyleConst.kSpacing,
    justifyContent: "space-between",
  },
  P99_LeftSideMenu: {
    marginRight: 5 * kStyleConst.kSpacing,
    width: 200,
  },
  P99_LeftSideMenuDisabled: {
    marginRight: 5 * kStyleConst.kSpacing,
    width: 200,
    opacity: 0.4,
  },
  P99_MobileSortOptions: {
    marginBottom: 5 * kStyleConst.kSpacing,
  },
  P99_MobileSortOptionsDisabled: {
    marginBottom: 5 * kStyleConst.kSpacing,
    opacity: 0.4,
  },
  P99_SearchContainer: {
    flexDirection: "column",
  },
  P99_SearchBoxResults: {
    borderBottomColor: kColors.brandPink,
    borderBottomWidth: 1,
    flexDirection: "row",
    alignItems: "center",
    flex: 1,
  },
  gSubHeaderCell: {
    marginHorizontal: 6 * kStyleConst.kSpacing,
  },
  P99_SearchBoxContainer: {
    flexDirection: "row",
    alignItems: "center",
  },
  P99_SearchBoxInput: {
    borderRadius: 2,
    flex: 1,
    outlineWidth: 0,
    paddingLeft: kStyleConst.kSpacing,
    marginStart: kStyleConst.kSpacing,
  },
  P99_CategorySeparator: {
    borderBottomWidth: 0.75,
    marginBottom: 3 * kStyleConst.kSpacing,
  },
  P99_SubCategoryItem: {
    marginBottom: 4 * kStyleConst.kSpacing,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  P99_CategoryItem: {
    marginBottom: 4 * kStyleConst.kSpacing,
    flexDirection: "row",
    alignItems: "center",
  },
  P99_CategoryContainer: {
    marginTop: 8 * kStyleConst.kSpacing,
  },
  P99_EthosContainer: {
    marginTop: 4 * kStyleConst.kSpacing,
  },
  P99_BrandContainer: {
    flexDirection: "row",
  },
  P99_BrandsList: {
    paddingRight: 24 * kStyleConst.kSpacing,
  },
  P99_PaginationNumber: {
    marginHorizontal: kStyleConst.kSpacing,
  },
  P99_PaginationContainer: {
    alignSelf: "flex-end",
    marginBottom: 20 * kStyleConst.kSpacing,
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "center",
  },
  P99_FilterItem: {
    marginBottom: 4 * kStyleConst.kSpacing,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  P99_FilterItemBox: {
    flexDirection: "row",
    alignItem: "center",
  },
  P99_FilterItemCheckbox: {
    ...kStyleConst.kLegendStamp,
    marginRight: 2 * kStyleConst.kSpacing,
  },
  P99_RefinementListSeparator: {
    marginTop: 4 * kStyleConst.kSpacing,
    borderTopWidth: 1,
    borderTopColor: kColors.brandPink,
    marginBottom: 4 * kStyleConst.kSpacing,
  },
  P99_BrandEthosTitle: {
    marginBottom: 4 * kStyleConst.kSpacing,
  },
  P99_BrandCardImage: {
    alignSelf: "stretch",
    height: 380,
  },
  P99_BlankImages: {
    ...kStyleConst.kOneByOne,
    opacity: 0,
  },
  P99_BrandCardArrowRight: {
    position: "absolute",
    top: 0,
    bottom: 0,
    alignItems: "center",
    justifyContent: "center",
    right: 0,
    paddingHorizontal: 2 * kStyleConst.kSpacing,
  },
  P99_BrandCardArrowLeft: {
    position: "absolute",
    top: 0,
    bottom: 0,
    alignItems: "center",
    justifyContent: "center",
    left: 0,
    paddingHorizontal: 2 * kStyleConst.kSpacing,
  },
  P99_BrandCardButton: {
    backgroundColor: kColors.transparentGray,
    height: 30,
    width: 30,
    padding: 5,
    borderRadius: 30,
    alignItems: "center",
    justifyContent: "center",
  },
  P99_BrandCardImagePlaceholder: {
    alignSelf: "stretch",
    height: 380,
    backgroundColor: kColors.gray,
  },
  P99_BrandCartNameArea: {
    marginVertical: 3 * kStyleConst.kSpacing,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  P99_BrandCardInfoArea: {
    flexDirection: "column",
    flex: 1,
  },
  P99_BrandCardShopButton: {
    width: 115,
    borderBottomColor: kColors.black,
    borderBottomWidth: 1.75,
    marginTop: 3.5 * kStyleConst.kSpacing,
  },
  P99_HeroBanner: {
    alignSelf: "stretch",
    height: kStyleConst.kHeroBannerHeight,
    backgroundColor: kColors.gray,
  },
  P99_HeroBannerMobile: {
    alignSelf: "stretch",
    height: kStyleConst.kBrandBannerHeightSmall,
    backgroundColor: kColors.gray,
  },
  P99_BrandCardPriceText: {
    marginBottom: kStyleConst.kSpacing,
  },
  P100_Container: {
    flexDirection: "column",
  },
  P100_ModelContainer: {
    flexDirection: "column",
    flex: 1,
    maxWidth: 1000,
    minWidth: 415,
  },
  P100_ModelContainerSmall: {
    flexDirection: "column",
    flex: 1,
    width: "100%",
  },
  P100_ModalBackground: {
    alignItems: "center",
    backgroundColor: kColors.transparentBlack,
    bottom: 0,
    justifyContent: "center",
    left: 0,
    paddingHorizontal: 10 * kStyleConst.kSpacing,
    position: "absolute",
    right: 0,
    top: 0,
    zIndex: 15,
  },
  P100_ModalBackgroundSmall: {
    alignItems: "center",
    backgroundColor: kColors.transparentBlack,
    bottom: 0,
    justifyContent: "center",
    left: 0,
    position: "absolute",
    right: 0,
    top: 0,
    zIndex: 15,
  },
  P100_HeaderContainer: {
    zIndex: 10,
  },
  P100_ModelHeaderContainer: {
    zIndex: 10,
  },
  P100_AttachmentLinkIcon: {
    ...kStyleConst.kExternalLinkIconDimensions,
    marginEnd: kStyleConst.kSpacing,
    marginTop: 10,
  },
  P100_ModalContainer: {
    flexDirection: "column",
    padding: 6 * kStyleConst.kSpacing,
    zIndex: 1,
  },

  P100_HeaderBanner: {
    width: "100%",
    height: kStyleConst.kBrandBannerHeight,
    backgroundColor: kColors.gray,
    overflow: "hidden",
  },
  P100_MobileHeader: {
    width: "100%",
    height: kStyleConst.kBrandBannerHeightSmall,
    backgroundColor: kColors.gray,
    zIndex: 5,
  },

  P100_AboutBrand: {
    alignSelf: "flex-start",
    width: kStyleConst.kReadStoryModelWidth,
    borderTopWidth: 1,
    borderTopColor: kColors.brandDark,
    marginTop: 5 * kStyleConst.kSpacing,
    marginBottom: 5 * kStyleConst.kSpacing,
  },
  P100_BrandReadMoreModelHeader: {
    width: "100%",
    height: kStyleConst.kBrandBannerHeight,
    backgroundColor: kColors.brandDarkGreen,
    overflow: "hidden",
  },
  P100_ModelHeaderBanner: {
    width: "100%",
    height: kStyleConst.kBrandBannerHeight,
    backgroundColor: kColors.brandDarkGreen,
    justifyContent: "center",
    flexDirection: "row",
  },
  P100_ModelCancelIcon: {
    position: "absolute",
    top: 10,
    right: 10,
  },
  P100_ModelCancelIconSmall: {
    position: "absolute",
    top: 10,
    right: 10,
    marginRight: 10,
  },
  P100_HeaderOverlay: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  P100_ModelHeaderOverlay: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  P100_ModelHeaderOverlaySmall: {
    flexDirection: "row",
  },
  P100_Icon: {
    width: kStyleConst.kBrandIconDiameter,
    height: kStyleConst.kBrandIconDiameter,
    borderRadius: 999,
    marginLeft: 24 * kStyleConst.kSpacing,
    marginTop: -30 * kStyleConst.kSpacing,
  },
  P100_IconMobile: {
    position: "absolute",
    width: kStyleConst.kBrandIconMobileDiameter,
    height: kStyleConst.kBrandIconMobileDiameter,
    borderRadius: kStyleConst.kBrandIconMobileDiameter / 2,
    left: 5 * kStyleConst.kSpacing,
    bottom: -50,
  },
  P100_ModelIcon: {
    width: kStyleConst.kBrandIconDiameter,
    height: kStyleConst.kBrandIconDiameter,
    borderRadius: 999,
    marginLeft: 24 * kStyleConst.kSpacing,
    marginTop: -30 * kStyleConst.kSpacing,
    // overflow: "hidden",
  },
  P100_ModelIconSmall: {
    width: kStyleConst.kBrandIconDiameterSmall,
    height: kStyleConst.kBrandIconDiameterSmall,
    borderRadius: 999,
    marginTop: "auto",
    marginBottom: "auto",
    alignSelf: "flex-start",
  },
  P100_ModelNameAndLocationSmall: {
    width: kStyleConst.kBrandIconDiameter,
    height: kStyleConst.kBrandIconDiameter,
    marginLeft: 7 * kStyleConst.kSpacing,
    justifyContent: "center",
    marginTop: "auto",
    marginBottom: "auto",
  },
  P100_ModalHeader: {
    alignItems: "flex-start",
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 3 * kStyleConst.kSpacing,
  },
  P100_InfoContainer: {
    flexDirection: "row",
    marginTop: 30 * kStyleConst.kSpacing - kStyleConst.kBrandIconDiameter,
  },
  P100_ModelInfoContainer: {
    flexDirection: "row",
    marginTop: 30 * kStyleConst.kSpacing - kStyleConst.kBrandIconDiameter,
  },
  P100_ModelInfoContainerSmall: {
    flexDirection: "column",
    marginTop: 30 * kStyleConst.kSpacing - kStyleConst.kBrandIconDiameter,
  },
  P100_ConnectButton: {
    backgroundColor: kColors.brandGreen,
    width: kStyleConst.kLongButtonWidth,
    height: kStyleConst.kLongButtonWidth / 5,
    marginRight: 20 * kStyleConst.kSpacing,
    marginTop: -20 * kStyleConst.kSpacing,
    justifyContent: "center",
    alignItems: "center",
  },
  P100_ConnectButtonPending: {
    backgroundColor: kColors.lightMed,
    width: kStyleConst.kLongButtonWidth,
    height: kStyleConst.kLongButtonWidth / 5,
    marginRight: 20 * kStyleConst.kSpacing,
    marginTop: -20 * kStyleConst.kSpacing,
    justifyContent: "center",
    alignItems: "center",
  },
  P100_ConnectButtonMobile: {
    position: "absolute",
    backgroundColor: kColors.brandGreen,
    width: kStyleConst.kLongButtonWidth,
    height: kStyleConst.kLongButtonWidth / 5,
    right: 3 * kStyleConst.kSpacing,
    bottom: 3 * kStyleConst.kSpacing,
    justifyContent: "center",
    alignItems: "center",
  },
  P100_ConnectButtonMobilePending: {
    position: "absolute",
    backgroundColor: kColors.lightMed,
    width: kStyleConst.kLongButtonWidth,
    height: kStyleConst.kLongButtonWidth / 5,
    right: 3 * kStyleConst.kSpacing,
    bottom: 3 * kStyleConst.kSpacing,
    justifyContent: "center",
    alignItems: "center",
  },
  P100_InfoLeftContainer: {
    flex: 6,
    backgroundColor: kColors.grayPink,
    paddingLeft: 24 * kStyleConst.kSpacing,
    paddingRight: 12 * kStyleConst.kSpacing,
    paddingTop: 19 * kStyleConst.kSpacing,
    paddingBottom: 11 * kStyleConst.kSpacing,
    alignContent: "flex-start",
  },
  P100_InfoLeftContainerMobile: {
    backgroundColor: kColors.grayPink,
    paddingHorizontal: 5 * kStyleConst.kSpacing,
    paddingTop: 13 * kStyleConst.kSpacing,
    paddingBottom: 5 * kStyleConst.kSpacing,
    alignContent: "flex-start",
  },
  P100_ModelInfoLeftContainer: {
    flex: 7,
    backgroundColor: kColors.grayPink,
    paddingLeft: 16 * kStyleConst.kSpacing,
    paddingRight: 16 * kStyleConst.kSpacing,
    paddingTop: 19 * kStyleConst.kSpacing,
    paddingBottom: 20 * kStyleConst.kSpacing,
    alignContent: "flex-start",
  },
  P100_InfoRightContainerLower: {
    // flex: 8,
    backgroundColor: kColors.white,
    paddingHorizontal: 6 * kStyleConst.kSpacing,
    paddingTop: 14 * kStyleConst.kSpacing,
    alignContent: "center",
  },
  P100_InfoRightContainer: {
    flex: 8,
    backgroundColor: kColors.white,
    paddingLeft: 20 * kStyleConst.kSpacing,
    paddingRight: 24 * kStyleConst.kSpacing,
    paddingTop: 14 * kStyleConst.kSpacing,
    alignContent: "center",
  },
  P100_InfoRightContainerMobile: {
    flex: 8,
    backgroundColor: kColors.white,
    paddingHorizontal: kStyleConst.kSpacing * 4,
    paddingTop: 12 * kStyleConst.kSpacing,
    alignContent: "center",
  },
  P100_ModelInfoRightContainer: {
    flex: 8,
    backgroundColor: kColors.white,
    paddingLeft: 16 * kStyleConst.kSpacing,
    paddingRight: 16 * kStyleConst.kSpacing,
    paddingTop: 7 * kStyleConst.kSpacing,
  },
  P100_ModelMediaContainer: {
    alignItems: "center",
    flex: 1,
    paddingTop: "10%",
    backgroundColor: kColors.white,
  },
  P100_ModelMediaContainerGreyBackDrop: {
    backgroundColor: kColors.brandLight,
    paddingTop: 20 * kStyleConst.kSpacing,
    paddingLeft: "100%",
    paddingRight: "100%",
  },
  P100_Banner: {
    alignItems: "center",
    backgroundColor: kColors.backgroundGrey,
    flexDirection: "column",
    height: kStyleConst.kBannerHeight,
    justifyContent: "center",
    marginBottom: 141 / 2,
  },
  P100_ImageSelectRound: {
    alignItems: "center",
    backgroundColor: kColors.backgroundGrey,
    borderRadius: 360,
    flexDirection: "column",
    justifyContent: "center",
    marginTop: kStyleConst.kSpacing * 4,
  },
  P100_BrandReadModelImg1: {
    maxWidth: 590,
    maxHeight: 390,
    minWidth: 183,
    minHeight: 86,
    marginLeft: 20,
    marginRight: 300,
  },
  P100_BrandReadModelImg1Small: {
    maxWidth: 590,
    maxHeight: 390,
    minWidth: 183,
    minHeight: 86,
    marginLeft: 75,
    marginRight: 200,
  },
  P100_BrandReadModelImg2: {
    flex: 1,
    maxWidth: 424,
    maxHeight: 404,
    minWidth: 101,
    minHeight: 92,
    marginTop: kStyleConst.kSpacing * -30,
    marginLeft: 400,
    marginRight: 10,
  },
  P100_BrandReadModelImg2Small: {
    flex: 1,
    maxWidth: 424,
    maxHeight: 404,
    minWidth: 101,
    minHeight: 92,
    marginRight: 100,
    marginTop: kStyleConst.kSpacing * -5,
    marginLeft: 175,
  },
  P100_BrandReadModelImg3: {
    marginTop: 60,
    marginBottom: 60,
    flex: 1,
    marginLeft: 20,
    marginRight: 20,
    maxWidth: 774,
    maxHeight: 451,
    minWidth: 260,
    minHeight: 109,
  },
  P100_CheckedArea: {
    alignItems: "center",
    minWidth: kStyleConst.kMinWidth,
  },
  P100_Column: {
    flexDirection: "column",
    flex: 1,
    flexWrap: "wrap",
    minWidth: kStyleConst.kMinWidth,
  },
  P100_ModelColumn: {
    flexDirection: "column",
    marginLeft: 0,
    marginRight: 0,
  },
  P100Model2imgCol: {
    justifyContent: "center",
  },
  P100_TitleArea: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  P100_ModelTitleArea: {
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
  },
  P100_ModelTitleAreaSmall: {
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "space-between",
  },
  P100_Location: {
    marginTop: kStyleConst.kSpacing,
    marginBottom: 5 * kStyleConst.kSpacing,
    opacity: 0.9,
  },
  P100_ExclusiveIcon: {
    ...kFonts.bodySmallCenter,
    color: kColors.white,
    fontWeight: "400",
    letterSpacing: kStyleConst.kSlightLetterSpacing,
    alignSelf: "center",
  },
  P100_ExclusiveIconView: {
    backgroundColor: kColors.brandGreen,
    marginLeft: 4 * kStyleConst.kSpacing,
    borderRadius: 999,
    paddingHorizontal: 2 * kStyleConst.kSpacing,
    height: kStyleConst.kStoreFrontExclusiveBadgeHeight,
    justifyContent: "center",
    alignItems: "center",
  },
  P100_ExclusiveIconViewCard: {
    position: "absolute",
    top: 14,
    left: 14,
    backgroundColor: kColors.brandGreen,
    borderRadius: 19,
    paddingHorizontal: 2 * kStyleConst.kSpacing,
    height: kStyleConst.kStoreFrontExclusiveBadgeHeight,
    justifyContent: "center",
    alignItems: "center",
  },
  P100_ModelExclusiveIconSmall: {
    backgroundColor: kColors.brandGreen,
    borderRadius: 999,
    paddingHorizontal: 2 * kStyleConst.kSpacing,
    paddingVertical: kStyleConst.kSpacing,
  },
  P100_NameArea: {
    flexDirection: "row",
    alignItems: "center",
    marginRight: 4 * kStyleConst.kSpacing,
  },

  P100_BookmarkButton: {
    alignItems: "center",
  },
  P100_Bookmark: {
    ...kStyleConst.kBrandLandingBookmarkDimensions,
  },
  P100_EthosBox: {
    backgroundColor: kColors.brandDarkRed,
    padding: 2 * kStyleConst.kSpacing,
    marginRight: 4 * kStyleConst.kSpacing,
    marginBottom: 4 * kStyleConst.kSpacing,
  },
  P100_EthosArea: {
    flexWrap: "wrap",
    flexDirection: "row",
  },
  P100_ModelEthosAreaSmall: {
    marginTop: 4 * kStyleConst.kSpacing,
    flexWrap: "wrap",
    flexDirection: "row",
  },
  P100_textTitle: {
    marginBottom: 2 * kStyleConst.kSpacing,
  },

  P100_Minimums: {
    marginTop: kStyleConst.kSpacing,
    marginBottom: 3 * kStyleConst.kSpacing,
  },
  P100_slightlyTransparent: {
    opacity: 0.85,
  },
  P100_InfoUpperLeftContainer: {
    paddingBottom: 7 * kStyleConst.kSpacing,
    marginBottom: 7 * kStyleConst.kSpacing,
    borderBottomWidth: 1,
    borderBottomColor: kColors.black,
  },
  P100_ModelInfoUpperLeftContainer: {
    paddingBottom: 7 * kStyleConst.kSpacing,
    marginBottom: 7 * kStyleConst.kSpacing,
    borderBottomWidth: 1,
    borderBottomColor: kColors.black,
  },
  P100_SocialsContainer: {
    flexDirection: "row",
    marginBottom: 6 * kStyleConst.kSpacing,
  },
  P100_Social: {
    paddingRight: 3 * kStyleConst.kSpacing,
    borderRightColor: kColors.black,
    borderRightWidth: 0.75,
    marginRight: 3 * kStyleConst.kSpacing,
  },
  P100_MessageButton: {
    borderWidth: 1.5,
    borderColor: kColors.brandDark,
    justifyContent: "center",
    alignItems: "center",
    alignSelf: "flex-start",
    paddingVertical: 2 * kStyleConst.kSpacing,
    paddingHorizontal: 10 * kStyleConst.kSpacing,
    marginTop: 7 * kStyleConst.kSpacing,
  },
  P100_ReadStoryButton: {
    alignSelf: "flex-end",
    width: kStyleConst.kReadStoryButtonWidth,
    borderBottomWidth: 2,
    borderBottomColor: kColors.brandDark,
    marginTop: 7 * kStyleConst.kSpacing,
    marginBottom: 14 * kStyleConst.kSpacing,
  },

  P100_AboutBrandHeaderContainer: {},
  P100_AboutBrandHeaderText: {
    marginTop: 7 * kStyleConst.kSpacing,
    marginBottom: 5 * kStyleConst.kSpacing,
    borderTopWidth: 1,
    alignSelf: "flex-start",
    width: kStyleConst.kReadStoryModelWidth,
  },
  P100_ListContainer: {
    flexDirection: "row",
    flex: 1,
    flexWrap: "wrap",
  },
  P100_ProductArea: {
    marginHorizontal: 5 * kStyleConst.kSpacing,
    marginVertical: 16 * kStyleConst.kSpacing,
  },
  P100_ProductsHeader: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 12 * kStyleConst.kSpacing,
    zIndex: 2,
  },
  P100_PaginationFooter: {
    justifyContent: "flex-end",
  },
  P100_SearchArea: {
    flex: 1,
    flexDirection: "row",
    alignItems: "flex-end",
  },
  P100_SearchAreaMobile: {
    flex: 1,
    flexDirection: "column",
  },
  P100_SearchBox: {
    flex: 3,
    marginRight: 4 * kStyleConst.kSpacing,
  },
  P100_ProductCardPriceContainer: {
    flexDirection: "row",
    marginBottom: kStyleConst.kSpacing,
    alignItems: "center",
  },
  P101_ProductContainerRow: {
    flexDirection: "row",
    marginBottom: 60 * kStyleConst.kSpacing,
  },
  P101_ProductContainerCol: {
    flexDirection: "column",
    alignItems: "stretch",
  },
  P101_ImageArea: {
    flex: 1,
    flexDirection: "row",
    alignItems: "flex-start",
    alignSelf: "flex-start",
    marginTop: 12.5 * kStyleConst.kSpacing,
  },
  P101_ImageAreaSmall: {
    flexDirection: "row",
    alignItems: "center",
    alignSelf: "stretch",
  },
  P101_ImageClickableArea: {
    flexDirection: "row",
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  },
  P101_ImageClickable: {
    flex: 1,
  },
  P101_ImageClickableLeft: {
    position: "absolute",
    top: 0,
    bottom: 0,
    alignItems: "center",
    justifyContent: "center",
    left: 0,
    paddingHorizontal: 2 * kStyleConst.kSpacing,
  },
  P101_ImageClickableRight: {
    position: "absolute",
    top: 0,
    bottom: 0,
    alignItems: "center",
    justifyContent: "center",
    right: 0,
    paddingHorizontal: 2 * kStyleConst.kSpacing,
  },
  P101_DotImageList: {
    position: "absolute",
    right: 3 * kStyleConst.kSpacing,
    bottom: 4 * kStyleConst.kSpacing,
    flexDirection: "row",
  },
  P101_Dot: {
    ...kStyleConst.kDotDimensions,
    borderRadius: 999,
    marginHorizontal: kStyleConst.kSpacing,
    backgroundColor: kColors.brandDarkTransparent,
  },
  P101_DotSelected: {
    ...kStyleConst.kDotDimensions,
    borderRadius: 999,
    marginHorizontal: kStyleConst.kSpacing,
    backgroundColor: kColors.brandDark,
  },
  P101_InfoArea: {
    flex: 1,
    padding: 8 * kStyleConst.kSpacing,
  },
  P101_TopBar: {
    height: kStyleConst.kTopBarHeight,
    backgroundColor: kColors.brandGreen,
  },
  P101_BrandNameClickable: {
    alignSelf: "flex-start",
  },
  P101_ProductName: {
    marginTop: 8 * kStyleConst.kSpacing,
    marginBottom: 2 * kStyleConst.kSpacing,
  },
  P101_Pricing: {
    marginTop: 8 * kStyleConst.kSpacing,
    marginBottom: kStyleConst.kSpacing,
    flexDirection: "row",
    alignItems: "center",
  },
  P101_InfoHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
  },
  P101_ExclusiveIcon: {
    backgroundColor: kColors.brandGreen,
    borderRadius: 999,
    paddingHorizontal: 2 * kStyleConst.kSpacing,
    paddingVertical: kStyleConst.kSpacing,
    marginRight: 3 * kStyleConst.kSpacing,
  },
  P101_QuantityArea: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    marginVertical: 5 * kStyleConst.kSpacing,
  },
  P101_VariantsArea: {
    zIndex: 10,
  },
  P101_VariantContainer: {
    flexDirection: "row",
    alignItems: "flex-end",
    marginVertical: kStyleConst.kSpacing,
  },
  P101_VariantText: {
    minWidth: 11 * kStyleConst.kSpacing,
    marginRight: 8 * kStyleConst.kSpacing,
  },
  P101_TesterArea: {
    marginTop: 8 * kStyleConst.kSpacing,
    flexDirection: "row",
    alignItems: "center",
    alignSelf: "flex-start",
  },
  P101_TesterText: {
    marginLeft: 2 * kStyleConst.kSpacing,
    justifyContent: "flex-start",
    fontFamily: "Poppins",
    fontWeight: "500",
    fontSize: 16,
    color: kColors.brandDark,
  },
  P101_AddToCartButton: {
    ...kStyleConst.kAddToCartButtonDimensions,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: kColors.brandDarkGreen,
    marginBottom: 4 * kStyleConst.kSpacing,
    marginTop: 8 * kStyleConst.kSpacing,
  },
  P101_AddToCartButtonDisabled: {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: kColors.white,
    opacity: kStyleConst.kAddToCartDisabledOpacity,
  },
  P101_Divider: {
    paddingBottom: 8 * kStyleConst.kSpacing,
    borderBottomWidth: kStyleConst.kBorderWidthSmall,
    borderBottomColor: kColors.brandDark,
    marginBottom: 5 * kStyleConst.kSpacing,
  },
  P101_DescriptionText: {
    marginRight: 4 * kStyleConst.kSpacing,
    marginTop: 6 * kStyleConst.kSpacing,
  },
  P101_ImageList: {
    justifyContent: "center",
    marginHorizontal: 6 * kStyleConst.kSpacing,
    alignSelf: "flex-start",
    marginTop: 0,
  },
  P101_Thumbnail: {
    ...kStyleConst.kThumbnailDimensions,
    opacity: kStyleConst.kImageThumbnailOpacity,
  },
  P101_ThumbnailSelected: {
    ...kStyleConst.kThumbnailDimensions,
  },
  P101_ImageThumbnailButton: {
    marginBottom: 2 * kStyleConst.kSpacing,
  },
  P101_Image: {
    flex: 1,
  },
  P101_QuantityControl: {
    marginLeft: 5 * kStyleConst.kSpacing,
    flexDirection: "row",
  },
  P101_QuantityInput: {
    ...kStyleConst.kQuantityInputDimensions,
    borderWidth: kStyleConst.kBorderWidth,
    borderColor: kColors.brandDark,
    marginHorizontal: 4 * kStyleConst.kSpacing,
  },
  P03_01QuantityInputText: {
    justifyContent: "flex-start",
    alignItems: "flex-start",
    ...kStyleConst.kQuantityInputDimensions,
  },
  P101_QuantityInputText: {
    textAlign: "center",
  },
  gSubHeaderContainer: {
    backgroundColor: kColors.brandGreen,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: kStyleConst.kSubHeaderHeight,
  },
  gSubHeaderContainerSmall: {
    backgroundColor: kColors.brandGreen,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: kStyleConst.kSubHeaderHeightSmall,
  },
  alert: {
    alignItems: "center",
    borderRadius: 5,
    borderWidth: 1,
    flexDirection: "row",
    justifyContent: "space-between",
    marginVertical: 8,
    paddingHorizontal: 24,
    paddingVertical: 16,
  },
  alertClose: {
    height: 10,
    width: 10,
  },
  alignBottom: { bottom: 20, position: "absolute" },
  alignCenter: { alignItems: "center" },
  applyBody: {
    backgroundColor: kColors.brandLight,
    flex: 1,
    marginHorizontal: 13 * kStyleConst.kSpacing,
    paddingVertical: 7 * kStyleConst.kSpacing,
    zIndex: 5,
  },
  applyBooleanView: {
    alignItems: "center",
    flex: 1,
    flexDirection: "row",
    justifyContent: "flex-start",
  },
  applyButton: {
    alignItems: "center",
    backgroundColor: kColors.black,
    justifyContent: "center",
  },
  applyCheckBoxView: {
    height: 20,
    marginLeft: 10,
    width: 20,
  },
  applyComboBoxView: {
    backgroundColor: kColors.white,
    flexDirection: "row",
    zIndex: 10,
  },
  applyComboBoxViewFifteen: {
    backgroundColor: kColors.white,
    flexDirection: "row",
    zIndex: 15,
    marginBottom: kStyleConst.kSpacing,
  },
  applyComboBoxView2: {
    flexDirection: "row",
    marginTop: -3,
    paddingVertical: 2 * kStyleConst.kSpacing,
    zIndex: 10,
  },
  applyCompanyView: {
    zIndex: 5,
  },
  applyTextInputs: {
    flexDirection: "row",
    zIndex: 1,
  },
  applyView: {
    alignItems: "center",
    flexDirection: "row",
    flexGrow: 1,
    justifyContent: "space-between",
    marginBottom: 2 * kStyleConst.kSpacing,
  },
  applyToJoinView: {
    flexGrow: 1,
    justifyContent: "space-between",
    marginBottom: 2 * kStyleConst.kSpacing,
    zIndex: 12,
  },
  applyViewSmall: {
    alignItems: "center",
    flexDirection: "column",
    flexGrow: 1,
    justifyContent: "space-between",
    marginBottom: 2 * kStyleConst.kSpacing,
  },
  badge: {
    ...kFonts.body,
    backgroundColor: kColors.red,
    borderRadius: 999,
    color: kColors.white,
    height: kStyleConst.kBadgeHeight,
    paddingHorizontal: kStyleConst.kSpacing,
  },
  between: {
    position: "relative",
    zIndex: 1000,
    alignItems: "center",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
    marginTop: 6 * kStyleConst.kSpacing,
  },
  P03_01OderCommentAndTotalContainer: {
    flexWrap: "wrap",
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "space-between",
    marginHorizontal: 9 * kStyleConst.kSpacing,
  },
  bigHeader: {
    fontSize: 36,
    marginBottom: 16,
  },
  linkText: {
    ...kFonts.bodyBlackSemiBold,
    textDecorationLine: "underline",
  },
  bodyWhite: {
    ...kFonts.body,
    color: kColors.white,
  },
  bodyGreen: {
    ...kFonts.body,
    color: kColors.brandGreen,
  },
  bodyRed: {
    ...kFonts.body,
    color: kColors.secondaryRed,
  },
  bodyBlack: {
    ...kFonts.body,
    color: kColors.black,
  },
  bodyWhiteBig: {
    ...kFonts.bodyWhite,
    paddingVertical: kStyleConst.kSpacing,
  },
  bodyWhiteSmall: {
    ...kFonts.bodySmall,
    color: kColors.white,
  },
  bottomLine: {
    marginVertical: 16,
    paddingHorizontal: 10,
  },
  bottomLineItem: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 16,
  },
  brandCartCheckoutButton: {
    backgroundColor: kColors.white,
    borderWidth: kStyleConst.kBorderWidth,
    paddingHorizontal: 2 * kStyleConst.kSpacing,
    paddingVertical: kStyleConst.kSpacing,
    textAlign: "center",
  },
  brandCartContainer: {
    borderColor: kColors.brandPink,
    borderWidth: 2,
    flexDirection: "column",
    flex: 1,
    marginTop: 4 * kStyleConst.kSpacing,
    paddingHorizontal: 4 * kStyleConst.kSpacing,
  },
  brandCartHeaderContainer: {
    alignItems: "center",
    borderBottomWidth: 2,
    borderColor: kColors.brandPink,
    flexDirection: "row",
    justifyContent: "space-between",
    paddingVertical: 6 * kStyleConst.kSpacing,
  },
  brandCartHeaderContainerMobile: {
    alignItems: "stretch",
    borderBottomWidth: 2,
    borderColor: kColors.brandPink,
    flexDirection: "column",
    justifyContent: "space-between",
    paddingTop: 2 * kStyleConst.kSpacing,
    paddingBottom: 3 * kStyleConst.kSpacing,
  },
  brandCartItemContainer: {
    flex: 1,
    flexWrap: "wrap",
    flexDirection: "row",
    justifyContent: "space-between",
    marginVertical: 2 * kStyleConst.kSpacing,
  },
  brandCartItemContainerPrices: {
    alignItems: "center",
    flexDirection: "row",
    flex: 1,
    flexWrap: "wrap",
    justifyContent: "space-between",
    maxWidth: 500,
    minWidth: 300,
  },
  brandCartItemContainerPriceAndCancel: {
    alignItems: "center",
    flexDirection: "row",
    flex: 1,
    flexWrap: "wrap",
    justifyContent: "space-between",
  },
  brandCartItemContainerPricesSmall: {
    flexDirection: "row",
    flex: 1,
    justifyContent: "space-between",
  },
  brandCartItemContainerPriceAndCancelSmall: {
    alignItems: "center",
    flexDirection: "row",
    flex: 1,
    flexWrap: "wrap",
    maxWidth: 500,
    minWidth: 300,
  },
  brandCartItemContainerSmall: {
    flex: 1,
    flexDirection: "column",
    justifyContent: "space-between",
    marginVertical: 3 * kStyleConst.kSpacing,
  },
  brandCartItemContainerTitle: {
    flexDirection: "row",
    marginBottom: 2 * kStyleConst.kSpacing,
  },
  brandCartItemContainerTitleSmall: {
    flexDirection: "column",
  },
  brandCartItemInfoColumnLeft: {
    flexDirection: "column",
    justifyContent: "space-between",
  },
  brandCartItemInfoColumnRight: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  brandCartItemInfoContainer: {
    flex: 1,
    flexDirection: "row",
  },
  brandCartItemInfoPriceView: {
    flexDirection: "column",
  },
  brandCartItemInfoQuantity: {
    textAlign: "center",
    flexDirection: "row",
  },
  brandCartItemInfoText: {
    ...kFonts.poppinsLight,
    color: kColors.black,
    whiteSpace: "nowrap",
  },
  brandCartItemInfoTextCheckOut: {
    ...kFonts.poppinsBold,
    color: kColors.black,
    fontSize: kStyleConst.kFontSizeMedium,
    fontWeight: "600",
  },
  brandInCartItemInfoTextCheckOut: {
    ...kFonts.poppinsBold,
    color: kColors.black,
    fontSize: kStyleConst.kFontSizeMedium,
    fontWeight: "600",
  },
  brandCartItemInfoTextPrice: {
    ...kFonts.poppinsLight,
    color: kColors.black,
    fontSize: kStyleConst.kFontSizeMedium,
    paddingBottom: 2 * kStyleConst.kSpacing,
  },
  brandCartItemInfoTextView: {
    width: kStyleConst.kCartItemTitleTextBox,
    marginTop: "auto",
    marginBottom: "auto",
  },
  brandCartSaveContainer: {
    alignItems: "center",
    borderTopColor: kColors.brandPink,
    borderTopWidth: 2,
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
    paddingVertical: 2 * kStyleConst.kSpacing,
  },
  brandCartSaveContainerMobile: {
    alignItems: "stretch",
    borderTopColor: kColors.brandPink,
    borderTopWidth: 2,
    flexDirection: "column",
    flexWrap: "wrap",
    justifyContent: "space-between",
    paddingVertical: 2 * kStyleConst.kSpacing,
  },
  brandCartShipPOBox: {
    ...kStyleConst.kBrandCartShipPOBox,
    borderColor: kColors.lightMed,
    borderRadius: 2,
    borderWidth: 1,
    padding: 2 * kStyleConst.kSpacing,
  },
  brandCartShipDiscountBoxError: {
    ...kStyleConst.kBrandCartShipPOBox,
    borderColor: kColors.red,
    borderRadius: 2,
    borderWidth: 1,
    padding: 2 * kStyleConst.kSpacing,
  },
  brandCartExtraContainer: {
    flexDirection: "row",
    flex: 1,
    flexWrap: "wrap",
    justifyContent: "space-between",
  },
  brandCartShipPOContainer: {
    flexDirection: "row",
    flex: 1,
    alignContent: "center",
    minWidth: 300,
    marginBottom: 4 * kStyleConst.kSpacing,
  },
  brandCartShipPOText: {
    ...kFonts.poppinsLight,
    alignSelf: "center",
    width: 80,
    marginEnd: 2 * kStyleConst.kSpacing,
  },
  brandCartShippingChangeText: {
    ...kFonts.poppinsLight,
    color: kColors.black,
    fontSize: kStyleConst.kFontSizeMedium,
    textDecorationLine: "underline",
  },
  brandCartShippingContainer: {
    borderColor: kColors.gray,
    flexDirection: "row",
    paddingVertical: 2 * kStyleConst.kSpacing,
  },
  brandCartShippingText: {
    ...kFonts.poppinsLight,
    fontColor: kColors.black,
    fontSize: kStyleConst.kFontSizeMedium,
    marginRight: kStyleConst.kSpacing,
  },
  brandCardSKUText: {
    ...kFonts.poppinsLight,
  },
  brandCartShippingTotalsContainer: {
    alignItems: "flex-end",
    flexDirection: "column",
    marginRight: 6 * kStyleConst.kSpacing,
    marginTop: 2 * kStyleConst.kSpacing,
  },
  brandCartTitle: {
    color: kColors.black,
    fontSize: kStyleConst.kFontSizeMedium,
    fontWeight: "600",
  },
  brandCartTitleMobile: {
    color: kColors.black,
    fontSize: kStyleConst.kFontSizeMedium,
    fontWeight: "600",
    marginBottom: 3 * kStyleConst.kSpacing,
  },
  brandCartTotalPrice: {
    color: kColors.backgroundGrey,
    fontSize: kStyleConst.kFontSizeMedium,
  },
  cartQuantityChangeDown: {
    ...kStyleConst.kQuantityChangeBox,
    borderColor: kColors.brandCoral,
    borderRadius: 5,
    borderWidth: 1,
    alignItems: "center",
  },
  cartQuantityChangeDownSymbol: {
    ...kStyleConst.kQuantityChangeBoxDownSymbol,
    color: kColors.brandCoral,
  },
  cartQuantityChangeNumber: {
    ...kStyleConst.kQuantityChangeBox,
    textAlign: "center",
    marginLeft: 3 * kStyleConst.kSpacing,
    marginRight: 3 * kStyleConst.kSpacing,
  },
  cartQuantityChangeUp: {
    ...kStyleConst.kQuantityChangeBox,
    borderColor: kColors.brandCoral,
    borderRadius: 5,
    borderWidth: 1,
    alignItems: "center",
  },
  cartQuantityChangeUpSymbol: {
    ...kStyleConst.kQuantityChangeBoxUpSymbol,
    color: kColors.brandCoral,
    textAlign: "center",
  },
  center: {
    alignItems: "center",
    flex: 1,
    justifyContent: "center",
  },
  chatContainer: {
    flex: 1,
  },
  chatContainerSmall: {
    flex: 1,
    marginHorizontal: 9 * kStyleConst.kSpacing,
  },
  chatInChatStyling: {},
  checkGroupContainer: {
    flexDirection: "column",
  },
  checkGroupContainerRow: {
    flexDirection: "row",
  },
  checkboxLabel: {
    marginLeft: 8,
    marginRight: 16,
  },
  checkOutContainer: {
    flex: 1,
    flexDirection: "row",
    paddingBottom: 10 * kStyleConst.kSpacing,
  },
  checkOutContainerSmall: {
    flex: 1,
    flexDirection: "column",
    paddingBottom: 10 * kStyleConst.kSpacing,
  },
  checkoutScrollView: {
    alignContent: "center",
  },
  checkoutProductContainer: {
    alignItems: "stretch",
    flex: 1,
    flexDirection: "column",
    minWidth: 300,
    paddingHorizontal: 6 * kStyleConst.kSpacing,
  },
  checkoutSummaryContainer: {
    flexDirection: "column",
    marginRight: 6 * kStyleConst.kSpacing,
  },
  checkoutSummaryContainerSmall: {
    alignSelf: "center",
  },
  checkoutTitleFontBag: {
    ...kFonts.poppinsRegularMedium,
    fontSize: 22,
    marginTop: 11 * kStyleConst.kSpacing,
  },
  checkoutTitleFontSummary: {
    ...kFonts.poppinsRegularMedium,
    fontSize: 22,
    marginBottom: 4 * kStyleConst.kSpacing,
    marginTop: 11 * kStyleConst.kSpacing,
  },
  circleIndicatorGreen: {
    alignSelf: "center",
    backgroundColor: kColors.green,
    borderRadius: 16 / 2,
    height: 16,
    marginBottom: 16,
    marginLeft: 8,
    marginRight: 8,
    marginTop: 16,
    width: 16,
  },
  circleIndicatorRed: {
    alignSelf: "center",
    backgroundColor: kColors.red,
    borderRadius: 16 / 2,
    height: 16,
    marginBottom: 16,
    marginLeft: 8,
    marginRight: 8,
    marginTop: 16,
    width: 16,
  },
  comboBox: {
    alignItems: "center",
    borderBottomWidth: 1,
    borderColor: kColors.brandPink,
    borderRadius: 2,
    flex: 1,
    flexDirection: "row",
    height: 36,
    justifyContent: "space-between",
    paddingEnd: 10,
    paddingTop: 5,
  },
  comboBoxIcon: {
    alignItems: "flex-end",
    alignSelf: "center",
    flex: 1,
    height: 7,
    justifyContent: "center",
    zIndex: 3,
  },
  comboBoxDropdown: {
    backgroundColor: kColors.white,
    borderBottomWidth: 1,
    borderColor: kColors.lightBlack,
    borderEndWidth: 1,
    borderStartWidth: 1,
    left: 0,
    maxHeight: 169,
    position: "absolute",
    shadowColor: kColors.black,
    shadowOffset: { width: 5, height: 5 },
    shadowOpacity: 0.1,
    shadowRadius: 10,
    top: 39,
    width: "100%",
    zIndex: 10,
  },
  comboBoxDropdownImage: {
    height: 70,
    resizeMode: "cover",
    width: 70,
  },
  comboBoxDropdownItem: {
    alignItems: "center",
    borderBottomColor: kColors.lightBlack,
    borderBottomWidth: 1,
    flexDirection: "row",
    zIndex: 20,
  },
  comboBoxDropdownItemActive: {
    alignItems: "center",
    backgroundColor: kColors.almostWhite,
    borderBottomColor: kColors.lightBlack,
    borderBottomWidth: 1,
    flexDirection: "row",
    fontWeight: "bold",
  },
  comboBoxDropdownItemText: {
    paddingHorizontal: 10,
    paddingVertical: 12,
  },
  comboBoxDropdownItemTextActive: {
    fontWeight: "bold",
    paddingHorizontal: 10,
    paddingVertical: 12,
  },
  comboBoxDropdownItemTextUnavailable: {
    paddingHorizontal: 10,
    paddingVertical: 12,
    color: kColors.gray,
  },
  comboBoxCancelIcon: {
    ...kStyleConst.kCancelIcon,
    marginBottom: "auto",
    marginTop: "auto",
  },
  comboBoxCancelIconContainer: {
    marginBottom: "auto",
    marginTop: "auto",
  },
  placeholderPortrait: {
    height: 15 * kStyleConst.kSpacing,
    marginRight: 2 * kStyleConst.kSpacing,
    width: 15 * kStyleConst.kSpacing,
  },
  topBannerContainer: {
    ...kStyleConst.kTopBannerContainer,
    backgroundColor: kColors.brandDarkGreen,
    borderRadius: 2,
    justifyContent: "center",
    marginVertical: 4 * kStyleConst.kSpacing,
  },
  comboBoxInput: {
    borderColor: kColors.transparent,
    borderWidth: 0,
    outlineColor: kColors.transparent,
    paddingHorizontal: kStyleConst.kSpacing * 2,
    paddingVertical: kStyleConst.kSpacing * 2,
    position: "absolute",
    width: "100%",
    zIndex: 2,
  },
  comboBoxInputDisabled: {
    borderColor: kColors.transparent,
    borderWidth: 0,
    color: kColors.lightMed,
    outlineColor: kColors.transparent,
    paddingHorizontal: kStyleConst.kSpacing * 2,
    paddingVertical: kStyleConst.kSpacing * 2,
    position: "absolute",
    width: "100%",
    zIndex: 2,
  },
  commissionTextInput: { height: 30, width: 300 },
  container: {
    marginHorizontal: "auto",
    maxWidth: 800,
    width: "100%",
  },
  gTablePageInnerContainer: {
    marginHorizontal: 13 * kStyleConst.kSpacing,
  },
  conversation: {
    alignItems: "center",
    borderRadius: 5,
    flexDirection: "row",
    paddingHorizontal: 10,
    paddingVertical: 8,
  },
  conversationAvatar: {
    borderRadius: 99,
    height: 50,
    marginEnd: 16,
    width: 50,
  },
  conversationMenu: {
    borderColor: kColors.brandPink,
    borderEndWidth: kStyleConst.kBorderWidth,
    maxWidth: kStyleConst.kSpacing * 60, // width: 300
    padding: 4 * kStyleConst.kSpacing,
  },
  conversationMenuSmall: {
    flex: 1,
    margin: 4 * kStyleConst.kSpacing,
  },
  conversationRecipient: {
    fontWeight: "bold",
  },
  conversationRole: {
    fontStyle: "italic",
  },
  currentConversationAvatar: {
    alignSelf: "center",
    borderRadius: 99,
    height: 70,
    width: 70,
  },
  P03_01ProductPicture: {
    ...kStyleConst.kProductPicSmall,
    alignSelf: "center",
  },
  currentConversationHeader: {
    alightItems: "center",
    backgroundColor: kColors.white,
    borderBottomWidth: 1,
    borderColor: kColors.lightBlack,
    marginHorizontal: 9 * kStyleConst.kSpacing,
    paddingHorizontal: 24,
    paddingVertical: 16,
  },
  currentConversationHeaderLabel: {
    marginTop: 5,
  },
  currentConversationLeftButton: {
    left: 0,
    position: "absolute",
    top: 42,
  },
  currentConversationProfile: {
    alignItems: "center",
    alignSelf: "center",
    width: kStyleConst.kConvoProfileContainerWidth,
  },
  currentConversationRightButton: { textAlign: "right", width: "20%" },
  disabledCheckboxContainer: {
    alignItems: "center",
    flexDirection: "row",
    marginBottom: 16,
    opacity: 0.25,
  },
  disabledIcon: {
    alignItems: "center",
    height: 20,
    justifyContent: "center",
    opacity: 0.25,
    width: 20,
  },
  flexOne: {
    flex: 1,
  },
  leftHeaderContainer: {
    zIndex: 12,
    flexDirection: "row",
    alignItems: "center",
    position: "absolute",
    top: 1,
    bottom: 1,
    // right: 0,
    left: 0,
  },
  rightHeaderContainer: {
    flexDirection: "row",
    position: "absolute",
    alignItems: "center",
    top: 1,
    bottom: 1,
    right: 0,
    // left: 1,
  },
  flexGrow: {
    flexGrow: 1,
  },
  formArrayContainer: {
    flex: 1,
    zIndex: 10,
  },
  formArrayLabel: {
    fontSize: 24,
    fontWeight: "bold",
    marginBottom: 8,
    textAlign: "center",
    width: 30,
  },
  formArrayLeftBar: {
    alignItems: "center",
    borderColor: kColors.lightBlack,
    borderEndWidth: 1,
    marginBottom: 16,
    marginHorizontal: 10,
    paddingEnd: 16,
  },
  formButtonContainer: {
    alignItems: "center",
    flexDirection: "row",
    marginVertical: 16,
  },
  LeftFormButtonContainer: {
    alignItems: "center",
    flexDirection: "row",
    marginTop: 15,
  },
  RightFormButtonContainer: {
    alignItems: "center",
    flexDirection: "row",
    marginTop: 4 * kStyleConst.kSpacing,
  },
  formControl: {
    marginBottom: 16,
  },
  gBackgroundColor: {
    backgroundColor: kColors.white,
  },
  gBackgroundColorRed: {
    backgroundColor: kColors.red,
  },
  gButtonBlackText: {
    alignSelf: "center",
    marginTop: kStyleConst.kSpacing,
  },
  gButtonWhiteText: {
    alignSelf: "center",
    color: kColors.white,
    marginTop: kStyleConst.kSpacing,
  },
  gDisplayOff: {
    display: "none",
  },
  gDrawerContentButtonBlack: {
    ...kStyleConst.kStandardButtons,
    borderColor: kColors.black,
    borderRadius: kStyleConst.kBorderRadius,
    borderWidth: 1,
    justifyContent: "center",
    marginBottom: 4 * kStyleConst.kSpacing,
  },
  gDrawerBackButtonView: {
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "flex-start",
    paddingHorizontal: kStyleConst.kSpacing * 8,
    marginBottom: kStyleConst.kSpacing * 3,
  },
  gDrawerBackButtonIcon: {
    ...kStyleConst.kDrawerBackButtonDimensions,
    marginEnd: kStyleConst.kSpacing * 2,
  },
  gHeaderBackButtonIcon: {
    ...kStyleConst.kHeaderBackButtonDimensions,
  },
  gDrawerBackButtonText: {
    ...kFonts.body,
  },
  gDrawerBackButtonDivider: {
    alignSelf: "center",
    backgroundColor: kColors.white,
    height: 2,
    marginBottom: 6 * kStyleConst.kSpacing,
    width: 175,
  },
  gDrawerProfileName: {
    ...kFonts.bodyBold,
    flexDirection: "column",
    flexShrink: 1,
  },
  gCheckBoxLeftView: {
    flexDirection: "row",
  },
  gCheckBoxRightView: {
    flexDirection: "row-reverse",
  },
  gCheckBoxButtonView: {
    flexDirection: "row",
  },
  repApplicationTextStyle: {
    marginLeft: 2 * kStyleConst.kSpacing,
  },
  gDrawerContentButtonGreen: {
    ...kStyleConst.kStandardButtons,
    backgroundColor: kColors.brandDarkGreen,
    borderColor: kColors.brandDarkGreen,
    borderRadius: kStyleConst.kBorderRadius,
    borderWidth: 1,
    justifyContent: "center",
    marginBottom: 4 * kStyleConst.kSpacing,
  },
  gDrawerContentButtonGreenApplication: {
    ...kStyleConst.kStandardButtons,
    backgroundColor: kColors.brandDarkGreen,
    borderColor: kColors.brandDarkGreen,
    borderRadius: kStyleConst.kBorderRadius,
    justifyContent: "center",
  },
  gDrawerContentButtonGreenApplicationSmall: {
    ...kStyleConst.kStandardButtons,
    backgroundColor: kColors.brandDarkGreen,
    borderColor: kColors.brandDarkGreen,
    borderRadius: kStyleConst.kBorderRadius,
    marginTop: 30,
    justifyContent: "center",
  },
  gDrawerContentButtonText: {
    ...kFonts.body,
    alignSelf: "center",
  },
  gDrawerContentButtonTextWhite: {
    ...kFonts.bodyWhite,
    alignSelf: "center",
  },
  gDrawerWidth: {
    width: kStyleConst.kDrawerWidth,
  },
  gExternalLinkView: {
    flexDirection: "row",
  },
  gExternalLinkIcon: {
    ...kStyleConst.kExternalLinkIconDimensions,
    marginStart: kStyleConst.kSpacing,
    marginTop: 3,
  },
  gFormHeader: {
    ...kFonts.profileHeader,
    marginBottom: kStyleConst.kSpacing * 2,
  },
  gFormInput: {
    borderBottomWidth: 1,
    borderColor: kColors.brandPink,
    borderRadius: 2,
    flex: 1,
    height: 36,
    marginTop: 5,
    outlineColor: kColors.transparent,
    paddingLeft: kStyleConst.kSpacing,
    paddingRight: 40,
    paddingVertical: 10,
  },
  gFormLegend: {
    ...kFonts.formLegend,
  },
  gGreenButton: {
    backgroundColor: kColors.brandDarkGreen,
    borderRadius: 2,
    borderWidth: 0,
    color: kColors.white,
    fontSize: 12,
    paddingHorizontal: 16,
    paddingVertical: 10,
    textAlign: "center",
    textTransform: "uppercase",
  },
  gButton: {
    marginBottom: 0,
  },
  gLongButton: {
    borderColor: kColors.brandDarkGreen,
    borderRadius: 2,
    color: kColors.white,
    fontSize: 12,
    paddingHorizontal: 3 * kStyleConst.kSpacing,
    paddingVertical: 2 * kStyleConst.kSpacing,
    textAlign: "center",
    textTransform: "uppercase",
    width: kStyleConst.kLongButtonWidth,
  },
  gHeaderLeftContainer: {
    marginLeft: 10 * kStyleConst.kSpacing,
    justifyContent: "center",
  },
  gHeaderRightContainer: {
    alignItems: "center",
    flex: 1,
    flexDirection: "row",
    justifyContent: "flex-end",
    paddingEnd: 8 * kStyleConst.kSpacing,
  },
  gHeaderSpacing: {
    marginVertical: 15,
  },
  gHeaderTitle: {
    alignSelf: "stretch",
    height: kStyleConst.kHeaderHeight,
  },
  gHeaderTitleContainer: {
    alignItems: "center",
    flex: 1,
    justifyContent: "center",
  },
  gHeaderCartIconBadgeView: {
    alignItems: "center",
    backgroundColor: kColors.secondaryRed,
    borderRadius: kStyleConst.kCartBadgeDimension / 2,
    color: kColors.white,
    justifyContent: "center",
    height: kStyleConst.kCartBadgeDimension,
    position: "absolute",
    paddingHorizontal: kStyleConst.kSpacing,
    right: kStyleConst.kCartBadgeRight,
    top: kStyleConst.kCartBadgeTop,
    width: kStyleConst.kCartBadgeDimension,
  },
  gHidden: {
    height: 0,
    outlineColor: kColors.transparent,
    overflow: "hidden",
    width: 0,
  },
  gRibbon: {
    position: "absolute",
    backgroundColor: kColors.errorGrey,
    left: 0,
    right: 0,
    top: kStyleConst.kHeaderHeight,
    height: kStyleConst.kErrorHeight,
    zIndex: 100,
  },
  gRibbonContainer: {
    position: "absolute",
    justifyContent: "center",
    backgroundColor: kColors.errorGrey,
    left: 0,
    right: 0,
    top: kStyleConst.kHeaderHeight,
    height: kStyleConst.kErrorHeight,
    zIndex: 99,
  },
  gRibbonInnerContainer: {
    paddingLeft: 14 * kStyleConst.kSpacing,
    flexDirection: "row",
    alignItems: "center",
  },
  gRibbonButton: {
    position: "absolute",
    height: kStyleConst.kFontSizeBrandCartDelete,
    top: 9,
    right: 70,
  },
  gRibbonIndex: {
    zIndex: 100,
  },
  gRibbonCloseButtonColor: {
    color: kColors.red,
  },
  gRibbonCloseButton: {
    ...kStyleConst.kCheckBox,
    position: "absolute",
    top: 15,
    right: 15,
  },
  gRibbonText: {
    ...kFonts.poppinsLight,
    marginLeft: 2 * kStyleConst.kSpacing,
  },
  gRibbonSuccess: {
    alignItems: "center",
  },
  gRibbonError: {
    backgroundColor: kColors.red,
  },
  gSearchContainer: {
    borderBottomColor: kColors.brandPink,
    borderBottomWidth: 2,
    flexDirection: "row",
    marginVertical: 6 * kStyleConst.kSpacing,
    width: kStyleConst.kSearchContainerWidth,
    paddingBottom: kStyleConst.kSpacing,
  },
  gSpaceBetweenRow: {
    alignItems: "baseline",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  gStackScreenDefault: {
    backgroundColor: kColors.white,
    flex: 1,
  },
  gTablePageContainer: {
    backgroundColor: kColors.white,
    flexGrow: 1,
    marginBottom: 30 * kStyleConst.kSpacing,
    marginHorizontal: 9 * kStyleConst.kSpacing,
    marginTop: 11 * kStyleConst.kSpacing,
  },
  gApplyTablePageContainer: {
    backgroundColor: kColors.white,
    borderRadius: 8,
    flexGrow: 1,
    marginTop: 7 * kStyleConst.kSpacing,
    zIndex: 2,
  },
  gTablePageContainerBottom: {
    backgroundColor: kColors.white,
    borderRadius: 8,
    flexGrow: 1,
    marginVertical: 7 * kStyleConst.kSpacing,
    zIndex: 1,
  },
  gTablePageContainerAdmin: {
    backgroundColor: kColors.white,
    borderRadius: 8,
    flexGrow: 1,
    marginBottom: 7 * kStyleConst.kSpacing,
    zIndex: 1,
  },
  gTablePageScrollView: {
    backgroundColor: kColors.brandLight,
    flexGrow: 1,
  },
  gTableMobileSortOptionView1: {
    flexDirection: "column",
    zIndex: 15,
    marginTop: kStyleConst.kSpacing * 2,
  },
  gTableMobileSortOptionView2: {
    flexDirection: "column",
    zIndex: 10,
    marginTop: kStyleConst.kSpacing * 2,
  },
  gTableMobileSortLabels: {
    ...kFonts.formLegend,
    marginVertical: kStyleConst.kSpacing,
  },
  gApplyViewView: {
    alignItems: "stretch",
    backgroundColor: kColors.brandLight,
    flexDirection: "column",
    flexGrow: 1,
    marginHorizontal: 20 * kStyleConst.kSpacing,
  },
  gApplyViewAdmin: {
    alignItems: "stretch",
    backgroundColor: kColors.brandLight,
    flexDirection: "column",
    flexGrow: 1,
  },
  gApplyViewViewNoMargin: {
    alignItems: "stretch",
    backgroundColor: kColors.brandLight,
    flexDirection: "column",
    flexGrow: 1,
  },
  gTag: {
    alignItems: "center",
    backgroundColor: kColors.white,
    borderColor: kColors.brandPink,
    borderRadius: 999,
    borderWidth: 1,
    marginRight: 5,
    flexDirection: "row",
    paddingHorizontal: 8,
    paddingVertical: 2,
  },
  gTagDelete: {
    alignItems: "center",
    backgroundColor: kColors.brandPink,
    borderColor: kColors.brandPink,
    borderRadius: 999,
    borderWidth: 1,
    marginRight: 5,
    flexDirection: "row",
    paddingHorizontal: 8,
    paddingVertical: 2,
  },
  gTextItalicBold: {
    ...kFonts.bodyItalicBold,
    color: kColors.white,
    paddingTop: 2,
  },
  gTopButtonsContainer: {
    alignSelf: "stretch",
    flexDirection: "row",
    justifyContent: "space-between",
    margin: 3 * kStyleConst.kSpacing,
  },
  gTopButtonsContainerBig: {
    alignSelf: "stretch",
    flexDirection: "row",
    justifyContent: "space-between",
    marginHorizontal: 9 * kStyleConst.kSpacing,
    marginTop: 3 * kStyleConst.kSpacing,
  },
  gTopButtonsLeftContainer: {
    alignSelf: "center",
    flexDirection: "row",
  },
  gInvisible: {
    color: kColors.transparent,
    paddingHorizontal: kStyleConst.kSpacing * 2,
    zIndex: 0,
  },
  gTopButtonsTextInput: {
    marginLeft: 2 * kStyleConst.kSpacing,
    outlineColor: kColors.transparent,
    paddingBottom: 2,
  },
  gTmtLogo: { ...kStyleConst.kTmtTitle, marginTop: 24 },
  headerAdminDropdown: {
    backgroundColor: kColors.white,
    paddingHorizontal: 10,
    paddingVertical: 10,
  },
  headerContainer: {
    alignItems: "center",
    backgroundColor: kColors.white,
    borderBottomColor: kColors.mediumGrey,
    borderBottomWidth: 1,
    flexDirection: "row",
    height: kStyleConst.kHeaderHeight,
  },
  headerMenu: {
    flexDirection: "row",
  },
  headerMenuIcon: {
    ...kStyleConst.kHamburgerIcon,
  },
  headerIcon: {
    ...kStyleConst.kHamburgerIcon,
    marginRight: 4 * kStyleConst.kSpacing,
  },
  headerMenuItem: {
    marginLeft: 25,
  },
  horizontalRule: {
    marginBottom: 16,
  },
  icon: {
    alignItems: "flex-start",
    alignSelf: "center",
    flex: 1,
    height: 7,
    justifyContent: "center",
    zIndex: 3,
  },
  iconRight: {
    alignItems: "flex-end",
    alignSelf: "center",
    flex: 1,
    height: 7,
    justifyContent: "center",
    zIndex: 3,
  },
  RadioIconContainer: {
    alignItems: "flex-start",
    alignSelf: "center",
    flex: 1,
    height: 6 * kStyleConst.kSpacing,
    justifyContent: "center",
  },
  RadioIcon: {
    height: kStyleConst.kRadioButton,
  },
  input: {
    borderColor: kColors.lightBlack,
    borderRadius: 2,
    borderWidth: 1,
    flexGrow: 1,
    height: 36,
    marginTop: 5,
    outlineColor: kColors.transparent,
    paddingHorizontal: 10,
    paddingVertical: 10,
  },
  inputButtonRow: {
    alignItems: "flex-end",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  inputError: {
    borderColor: kColors.red,
    borderRadius: 2,
    borderWidth: 1,
    flex: 1,
    height: 36,
    marginTop: 5,
    paddingHorizontal: 10,
    paddingVertical: 10,
  },
  inputErrorLabel: {
    color: kColors.red,
    paddingLeft: kStyleConst.kSpacing,
    zIndex: 12,
  },
  inputErrorLabelNoPadding: {
    color: kColors.red,
    zIndex: 12,
  },
  inputLogin: {
    borderColor: kColors.brandPink,
    borderBottomWidth: 1,
    flex: 1,
    height: 36,
    marginTop: 4 * kStyleConst.kSpacing,
    outlineColor: kColors.transparent,
    paddingVertical: 2,
  },
  inputMessagesShimmer: {
    height: kStyleConst.kShimmerMessages,
    width: "100%",
  },
  inputShimmer: {
    height: kStyleConst.kSimmerHeight,
    width: "100%",
  },
  inputSuffix: {
    backgroundColor: kColors.almostWhite,
    borderColor: kColors.lightBlack,
    borderStartColor: kColors.lightBlack,
    borderWidth: 1,
    marginTop: 5,
    paddingHorizontal: 10,
    paddingVertical: 10,
  },
  inputWithSuffix: {
    borderBottomWidth: 1,
    borderColor: kColors.lightBlack,
    borderStartWidth: 1,
    borderTopWidth: 1,
    marginTop: 5,
    paddingHorizontal: 10,
    paddingVertical: 10,
  },
  italic: {
    fontStyle: "italic",
  },
  largeText: {
    ...kFonts.title,
  },
  light: {
    color: kColors.gray,
  },
  linkOverlayBackButton: {
    alignItems: "center",
    backgroundColor: kColors.black,
    justifyContent: "center",
    padding: kStyleConst.kSpacing,
  },
  linkOverlayBackButtonText: {
    color: kColors.white,
    fontSize: kStyleConst.kFontSizeMedium,
    fontWeight: "bold",
  },
  linkOverlayBox: {
    backgroundColor: kColors.white,
    flexDirection: "column",
    padding: 2 * kStyleConst.kSpacing,
  },
  linkOverlayContainer: {
    alignItems: "center",
    backgroundColor: kColors.gray,
    flexDirection: "column",
    justifyContent: "center",
  },
  linkOverlayHeaderContainer: {
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 2 * kStyleConst.kSpacing,
  },

  gBankAccountModalButtonContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 8 * kStyleConst.kSpacing,
  },
  gBankAccountModalInnerContainer: {
    alignItems: "flex-start",
    justifyContent: "space-between",
    marginBottom: 3 * kStyleConst.kSpacing,
  },
  gCheckMark2BoxContainer: {
    alignItems: "center",
    flexDirection: "row",
    flexWrap: "wrap",
    marginLeft: 2 * kStyleConst.kSpacing,
  },
  gApplyMultiCheckBoxInnerContainer: {
    flexDirection: "row",
    marginTop: 6 * kStyleConst.kSpacing,
    width: kStyleConst.kApplyMinWidth,
  },
  gApplyEMPTYMultiCheckBoxInnerContainer: {
    ...kStyleConst.kCheckBox,
    flexDirection: "row",
    marginTop: 6 * kStyleConst.kSpacing,
  },
  underPaymentTermsSpacing: { marginBottom: 7 * kStyleConst.kSpacing },
  gBankAccountModalOuterContainer: {
    alignItems: "stretch",
    backgroundColor: kColors.transparentBlack,
    bottom: 0,
    flex: 1,
    flexDirection: "row",
    justifyContent: "center",
    left: 0,
    position: "absolute",
    right: 0,
    top: 0,
    zIndex: 101,
  },
  gBankAccountScrollView: {
    alignItems: "center",
    justifyContent: "center",
  },
  gBankAccountModalContainer: {
    backgroundColor: kColors.white,
    flex: 1,
    marginHorizontal: 40 * kStyleConst.kSpacing,
    marginVertical: 20 * kStyleConst.kSpacing,
    maxHeight: 750,
    minWidth: 400,
    padding: 6 * kStyleConst.kSpacing,
    zIndex: 1,
  },
  mDrawer: {
    backgroundColor: kColors.brandLight,
    flex: 1,
    justifyContent: "space-between",
    width: kStyleConst.kDrawerWidth,
  },
  mDrawerLogOutButton: {
    colors: kColors.brandDark,
    marginHorizontal: 5 * kStyleConst.kSpacing,
    marginBottom: 4 * kStyleConst.kSpacing,
  },
  mDrawerActiveSubNavItem: {
    marginBottom: 3 * kStyleConst.kSpacing,
    marginLeft: 5 * kStyleConst.kSpacing,
  },
  mDrawerActiveSubText: {
    color: kColors.black,
    ...kFonts.body,
    fontWeight: "bold",
  },
  mDrawerActiveText: {
    ...kFonts.body,
    color: kColors.black,
    fontWeight: "600",
  },
  mDrawerButtonSpacing: {
    ...kStyleConst.kStandardButtons,
    marginBottom: 4 * kStyleConst.kSpacing,
  },
  mDrawerButtonView: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  mDrawerImageContainer: {
    alignItems: "center",
    justifyContent: "center",
  },
  mDrawerLogo: {
    height: 40,
    marginBottom: 16,
    resizeMode: "contain",
    width: 210,
  },
  mDrawerMenuView: {
    paddingHorizontal: 8 * kStyleConst.kSpacing,
  },
  mDrawerNavItem: {
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 3 * kStyleConst.kSpacing,
    marginRight: 3 * kStyleConst.kSpacing,
  },
  mDrawerNavText: {
    ...kFonts.body,
    color: kColors.black,
  },
  mDrawerProfile: {
    borderRadius: 999,
    height: 50,
    marginRight: 16,
    width: 50,
  },
  mDrawerProfileView: {
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 3 * kStyleConst.kSpacing,
    marginHorizontal: 6 * kStyleConst.kSpacing,
    marginTop: 8 * kStyleConst.kSpacing,
    overflow: "hidden",
  },
  mDrawerSeparatorBottom: {
    ...kStyleConst.kDrawerSeparatorsWidth,
    alignSelf: "center",
    backgroundColor: kColors.white,
    marginBottom: 2 * kStyleConst.kSpacing,
    marginTop: 7 * kStyleConst.kSpacing,
  },
  mDrawerSeparatorTop: {
    ...kStyleConst.kDrawerSeparatorsWidth,
    alignSelf: "center",
    backgroundColor: kColors.white,
    marginBottom: 4 * kStyleConst.kSpacing,
  },
  mDrawerSubNavItems: {
    marginStart: 10,
  },
  mFooter: {
    alignSelf: "stretch",
    backgroundColor: kColors.brandDarkGreen,
    height: kStyleConst.kFooterHeight,
    paddingHorizontal: 20 * kStyleConst.kSpacing,
  },
  mFooterBodyWhiteCONNECT: {
    ...kFonts.body,
    color: kColors.white,
    marginBottom: 2 * kStyleConst.kSpacing,
  },
  mFooterColumContainer: {
    flexDirection: "column",
    marginLeft: 15 * kStyleConst.kSpacing,
    marginTop: 2 * kStyleConst.kSpacing,
  },
  mFooterFlexDirectionContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 8 * kStyleConst.kSpacing,
  },
  mFooterLeftContainer: {
    marginRight: 8 * kStyleConst.kSpacing,
    marginTop: 9 * kStyleConst.kSpacing,
  },
  mFooterPolicyText: {
    flexDirection: "row",
  },
  mFooterRightContainer: {
    borderLeftColor: kColors.white,
    borderLeftWidth: 1,
    marginRight: 40 * kStyleConst.kSpacing,
    marginTop: 6 * kStyleConst.kSpacing,
  },
  mFooterRightTextSpacing: {
    marginVertical: 2 * kStyleConst.kSpacing,
  },
  mFooterSloganText: {
    alignSelf: "center",
    lineHeight: 5 * kStyleConst.kSpacing,
    marginLeft: 7 * kStyleConst.kSpacing,
    width: kStyleConst.kFooterSloganWidth,
  },
  mFooterSmallContainer: {
    alignSelf: "stretch",
    backgroundColor: kColors.brandDarkGreen,
    height: kStyleConst.kFooterHeightSmall,
    overflow: "visible",
  },
  mFooterSmallStampContainer: {
    left: 0,
    position: "absolute",
    top: -15,
  },
  mFooterSmallText: {
    ...kFonts.bodyWhite,
    marginLeft: 14 * kStyleConst.kSpacing,
    marginTop: kStyleConst.kSpacing,
  },
  mInviteButtonContainer: {
    ...kStyleConst.kStandardButtons,
    backgroundColor: kColors.brandDarkGreen,
    flexDirection: "row",
    justifyContent: "center",
    padding: 2 * kStyleConst.kSpacing,
  },
  mInviteButtonText: {
    ...kFonts.buttonText,
    marginLeft: kStyleConst.kSpacing,
  },
  mMenuIcon: {
    marginLeft: 6 * kStyleConst.kSpacing,
  },
  mShimmerContainer: {
    backgroundColor: kColors.white,
    height: "100%",
    position: "absolute",
    width: "100%",
    zIndex: 1,
  },
  mShimmerLinearGradient: {
    borderRadius: kStyleConst.kSpacing * 3,
    flex: 1,
  },
  mTableContainer: {
    backgroundColor: kColors.white,
    flex: 1,
  },
  marginBottom: {
    marginBottom: 16,
  },
  marginBottomCenter: {
    marginBottom: 16,
    textAlign: "center",
  },
  marginBottomSmall: {
    marginBottom: 8,
  },
  marginLeft: {
    marginLeft: 16,
  },
  marginVertical: {
    marginVertical: 16,
  },
  messagesContainer: {
    flex: 1,
    flexDirection: "row",
  },
  messagesContainerSmall: {
    flex: 1,
    flexDirection: "column",
  },
  modal: {
    backgroundColor: kColors.white,
    maxWidth: "90%",
    position: "absolute",
    shadowColor: kColors.black,
    shadowOffset: { height: 5, width: 5 },
    shadowOpacity: 0.1,
    shadowRadius: 20,
    width: 600,
  },
  modalBody: {
    paddingHorizontal: 20,
  },
  modalButtons: {
    flexDirection: "row",
    justifyContent: "space-between",
    paddingHorizontal: 20,
    marginTop: 50,
  },
  modalChangeRepButtons: {
    flexDirection: "row",
    justifyContent: "space-between",
    paddingHorizontal: 20,
    paddingVertical: 15,
  },
  modalChangeRepHeader: {
    ...kFonts.formLegend,
    borderBottomWidth: 1,
    borderColor: kColors.brandPink,
    flex: 1,
    marginHorizontal: 20,
    paddingVertical: 15,
    textAlign: "center",
  },
  modalChangeRepPrimaryButton: {
    alignItems: "center",
    borderColor: kColors.black,
    borderRadius: kStyleConst.kBorderRadius,
    borderWidth: 1,
    color: kColors.white,
    fontSize: 12,
    height: 40,
    justifyContent: "center",
    paddingHorizontal: 16,
    paddingVertical: 10,
  },
  modalChangeRepPrimaryText: {
    color: kColors.black,
    textTransform: "uppercase",
  },
  modalChangeRepSecondaryButton: {
    alignItems: "center",
    backgroundColor: kColors.black,
    borderRadius: kStyleConst.kBorderRadius,
    height: 40,
    justifyContent: "center",
    paddingHorizontal: 16,
    paddingVertical: 10,
  },
  modalChangeRepSecondaryText: {
    color: kColors.white,
    textTransform: "uppercase",
  },
  modalContainer: {
    alignItems: "center",
    backgroundColor: kColors.transparentWhite,
    bottom: 0,
    justifyContent: "center",
    left: 0,
    position: "absolute",
    right: 0,
    top: 0,
    zIndex: 10,
  },
  modalHeader: {
    flex: 1,
    fontSize: 22,
    fontWeight: "normal",
    paddingHorizontal: 20,
    paddingVertical: 15,
  },
  modalPrimaryButton: {
    width: 150,
    height: 40,
    backgroundColor: kColors.brandGreen,
    borderRadius: kStyleConst.kBorderRadius,
    borderWidth: 0,
  },
  modalSecondaryButton: {
    width: 150,
    height: 40,
    borderWidth: 1,
    borderColor: kColors.brandDarkGreen,
    borderRadius: kStyleConst.kBorderRadius,
  },
  numberInput: {
    flexDirection: "row",
  },
  numberInputUnit: {
    alignItems: "center",
  },
  numberInputText: {
    flex: 1,
    outlineColor: kColors.transparent,
  },
  numberUnit: {
    bottom: 11,
    position: "absolute",
    right: 10,
  },
  numberUnitDollar: {
    bottom: 11,
    left: 10,
    position: "absolute",
  },
  orderSummaryAlertContainer: {
    ...kStyleConst.kOrderSummaryAlertContainer,
    borderColor: kColors.brandDarkGreen,
    borderRadius: 2,
    borderWidth: 2,
    justifyContent: "center",
    marginVertical: 4 * kStyleConst.kSpacing,
    paddingLeft: 6 * kStyleConst.kSpacing,
    paddingRight: 7 * kStyleConst.kSpacing,
  },
  orderSummaryAlertBodyText: {
    ...kFonts.poppinsLight,
    lineHeight: 5 * kStyleConst.kSpacing,
    marginTop: 4 * kStyleConst.kSpacing,
    textAlign: "center",
  },
  orderSummaryAlertHeaderText: {
    ...kFonts.poppinsRegularMedium,
    alignSelf: "center",
    color: kColors.black,
  },
  orderSummaryContainer: {
    ...kStyleConst.kOrderSummaryContainer,
    alignContent: "center",
    backgroundColor: kColors.brandLight,
    borderRadius: 2,
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 1,
    paddingHorizontal: 3 * kStyleConst.kSpacing,
  },
  orderSummaryText: {
    alignSelf: "center",
  },
  orderSummaryTotalCheckout: {
    ...kFonts.poppinsLight,
    alignSelf: "center",
    color: kColors.white,
    fontSize: kStyleConst.kFontSizeMedium,
  },
  orderSummaryTotalPriceText: {
    alignSelf: "center",
    color: kColors.black,
    fontSize: kStyleConst.kFontSizeMedium,
    fontWeight: "bold",
  },
  paginationActive: {
    backgroundColor: kColors.lightBlack,
  },
  paginationContainer: {
    flexDirection: "row",
    marginTop: 16,
  },
  paginationDisabled: {
    opacity: 0.5,
  },
  paginationFirstItem: {
    borderColor: kColors.lightBlack,
    borderStartWidth: 1,
  },
  rowAlignCenter: {
    flexDirection: "row",
  },
  rowAlignCenterText: {
    marginLeft: 3 * kStyleConst.kSpacing,
    alignSelf: "center",
  },
  paginationItem: {
    alignItems: "center",
    borderBottomWidth: 1,
    borderColor: kColors.lightBlack,
    borderEndWidth: 1,
    borderTopWidth: 1,
    height: 40,
    justifyContent: "center",
    width: 40,
  },
  paginationLabel: {
    color: kColors.gray,
    fontSize: 18,
  },
  primaryButton: {
    color: kColors.brandDarkGreen,
    fontSize: 14,
    textAlign: "center",
    textTransform: "uppercase",
  },
  primaryButtonWhite: {
    color: kColors.white,
    fontSize: 14,
    textAlign: "center",
    textTransform: "uppercase",
  },
  quickAction: {
    // backgroundColor: kColors.almostWhite,
    borderRadius: 999,
    marginLeft: 20,
    paddingHorizontal: 24,
    paddingVertical: 20,
    shadowColor: kColors.black,
    shadowOffset: { width: 2, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 10,
  },
  quickActionSlider: {
    alignItems: "center",
    flexDirection: "row",
    marginVertical: 16,
    paddingHorizontal: 10,
  },
  regularText: {
    ...kFonts.body,
  },
  inviteRetailerRegularTextMargin: {
    marginTop: 2 * kStyleConst.kSpacing,
  },
  row: {
    position: "relative",
    zIndex: 1000,
    flexDirection: "row",
    marginTop: 3 * kStyleConst.kSpacing,
  },
  rowNoMargin: {
    flexDirection: "row",
    marginTop: 0,
  },
  rowClean: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    marginRight: 3 * kStyleConst.kSpacing,
  },
  flexWrap: {
    display: "flex",
    flexWrap: "wrap",
    maxWidth: "fit-content",
  },
  applyLogInText: {
    flexDirection: "row",
    alignSelf: "center",
    marginTop: 3 * kStyleConst.kSpacing,
    marginBottom: 5 * kStyleConst.kSpacing,
  },
  variantUnitView: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  variantDeleteView: {
    ...kStyleConst.kPlusMinusButton,
    alignSelf: "center",
  },
  rowColumn: {
    flex: 1,
    marginBottom: 16,
    paddingEnd: 16,
  },
  rowDoubleColumn: {
    flex: 2,
  },
  secondaryButton: {
    color: kColors.brandDarkGreen,
    fontSize: 14,
    paddingHorizontal: 16,
    paddingVertical: 10,
    textAlign: "center",
    textTransform: "uppercase",
  },
  sectionTitle: {
    alignSelf: "flex-start",
    fontSize: 22,
    marginBottom: 2 * kStyleConst.kSpacing,
  },
  sectionDate: {
    alignSelf: "flex-start",
    fontSize: 14,
    maxWidth: 155,
    marginRight: 4 * kStyleConst.kSpacing,
  },
  iconButton: { width: 158, height: 40, margin: 13 },
  sectionTitleSmall: {
    alignSelf: "center",
    fontSize: 22,
    marginBottom: 2 * kStyleConst.kSpacing,
    textAlign: "center",
  },
  statusText: {
    alignSelf: "center",
    fontSize: 20,
    fontWeight: "bold",
    marginVertical: 16,
  },
  tableCard: {
    flexDirection: "row",
    margin: 16,
    paddingHorizontal: 20,
    paddingTop: 16,
    shadowColor: kColors.lightBlack,
    shadowOffset: { width: 5, height: 5 },
    shadowRadius: 16,
  },
  tableSingleColumn: {
    flexDirection: "column",
    flex: 1,
  },
  tableColLeft: {
    flexDirection: "column",
    flex: 1,
    marginEnd: kStyleConst.kSpacing,
  },
  tableColRight: {
    flexDirection: "column",
    flex: 1,
    marginStart: kStyleConst.kSpacing,
  },
  tableCardCellWithLabel: {
    flex: 1,
    alignItems: "stretch",
    marginBottom: kStyleConst.kSpacing * 3,
    overflow: "hidden",
  },
  tableCardCellLabel: {
    color: kColors.gray,
    overflow: "visible",
  },
  gTableCell: {
    flex: 1,
    alignItems: "flex-start",
    flexDirection: "row",
    justifyContent: "flex-start",
    paddingHorizontal: kStyleConst.kSpacing * 2,
    paddingVertical: kStyleConst.kSpacing * 2,
    overflow: "hidden",
  },
  gCardCell: {
    alignItems: "flex-start",
    flexDirection: "row",
    justifyContent: "flex-start",
    paddingVertical: kStyleConst.kSpacing * 2,
    paddingEnd: kStyleConst.kSpacing * 2,
  },
  tableCardCell: {
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "flex-start",
  },
  tableHeader: {
    backgroundColor: kColors.white,
    borderBottomColor: kColors.brandPink,
    borderBottomWidth: 2,
    flexDirection: "row",
    justifyContent: "space-between",
  },
  tableHeaderButton: {
    alignItems: "center",
    flex: 1,
    flexDirection: "row",
    justifyContent: "flex-start",
  },
  tableHeaderLabel: {
    ...kFonts.body,
  },
  tableHeaderLabelSortActive: {
    ...kFonts.body,
    fontWeight: "600",
  },
  tableRow: {
    alignItems: "center",
    backgroundColor: kColors.white,
    flexDirection: "row",
    justifyContent: "space-between",
  },
  tableRowShaded: {
    backgroundColor: kColors.almostWhite,
  },
  gTableCellText: {
    ...kFonts.body,
    flex: 1,
  },
  mNoSearchAvailableContainer: {
    flexDirection: "column",
    flex: 1,
    flexWrap: "wrap",
  },
  mNoSearchTextContainer: {
    alignItems: "center",
    marginBottom: 10 * kStyleConst.kSpacing,
  },
  mNoCategoryTextContainer: {
    marginBottom: 5 * kStyleConst.kSpacing,
  },
  gTableCellTextBlackUnderline: {
    ...kFonts.body,
    flex: 1,
  },
  tag: {
    alignItems: "center",
    backgroundColor: kColors.almostWhite,
    borderColor: kColors.lightBlack,
    borderRadius: 999,
    borderWidth: 1,
    flexDirection: "row",
    marginRight: 5,
    paddingHorizontal: 8,
    paddingVertical: 2,
  },
  tagHighlighted: {
    alignItems: "center",
    backgroundColor: kColors.lightBlack,
    borderColor: kColors.lightBlack,
    borderRadius: 999,
    borderWidth: 1,
    flexDirection: "row",
    marginRight: 5,
    paddingHorizontal: 8,
    paddingVertical: 2,
  },
  tagDeleteView: {
    ...kStyleConst.kTagDeleteIconDimensions,
    marginStart: kStyleConst.kSpacing,
  },
  tagsInput: {
    flexDirection: "row",
    flexWrap: "wrap",
  },
  tagsTextInput: {
    flex: 1,
  },
  testGreen: {
    backgroundColor: kColors.testGreen,
  },
  testRed: {
    backgroundColor: kColors.red,
  },
  textArea: {
    borderColor: kColors.lightBlack,
    borderWidth: 1,
    flex: 1,
    height: 150,
    marginTop: 5,
    paddingHorizontal: 10,
    paddingVertical: 10,
  },
  textAreaError: {
    borderColor: kColors.red,
    borderWidth: 1,
    flex: 1,
    height: 150,
    marginTop: 5,
    paddingHorizontal: 10,
    paddingVertical: 10,
  },
  textRed: {
    color: kColors.red,
  },
  textRight: {
    textAlign: "right",
  },
  titleText: {
    color: kColors.black,
    fontSize: kFonts.title.fontSize,
    fontWeight: "bold",
  },
  toastContainer: {
    alignItems: "center",
    backgroundColor: kColors.white,
    borderColor: kColors.almostWhite,
    borderTopWidth: 2,
    flexDirection: "row",
    justifyContent: "space-between",
    paddingHorizontal: 20,
    paddingVertical: 20,
  },
  underlineText: {
    ...kFonts.body,
    textDecorationLine: "underline",
  },
  zIndexZero: { zIndex: 0 },
  zIndexTen: {
    zIndex: 10,
  },
  zIndexTwelve: {
    zIndex: 12,
  },
  zIndexFourteen: {
    zIndex: 14,
  },
  zzFooterTest: {
    backgroundColor: kColors.red,
    flexDirection: "row",
    flexGrow: 1,
  },
  zzTestTEMPORARY: {
    backgroundColor: kColors.green,
  },
});

// const webStyles: { [key: string]: CSSProperties } = {
//   P08_productThumbnail: {
//     ...kStyleConst.kListProductImageThumbnail,
//     marginRight: kStyleConst.kSpacing * 3,
//   },
//   P100_BrandReadModalImg: {
//     objectFit: "contain",
//     maxHeight: "inherit",
//     maxWidth: "inherit",
//   },
//   P101_ImageThumbnailButton: {
//     height: 55,
//     width: 55,
//     objectFit: "cover",
//   },
//   P101_Image: {
//     objectFit: "contain",
//     objectPosition: "top",
//     aspectRatio: "600/761",
//     height: 761,
//   },
//   P101_ImageSmall: {
//     objectFit: "cover",
//     height: 380,
//   },
// } as const;
